import { $ as e, $a as t, $c as n, $i as ee, $n as te, $o as ne, $r as re, $s as ie, $t as ae, A as oe, Aa as se, Ac as ce, Ai as le, An as ue, Ao as de, Ar as fe, As as pe, At as me, B as he, Ba as ge, Bc as _e, Bi as ve, Bn as ye, Bo as be, Br as xe, Bs as Se, Bt as Ce, C as r, Ca as i, Cc as a, Ci as o, Cn as s, Co as c, Cr as l, Cs as u, Ct as d, D as f, Da as p, Dc as m, Di as h, Dn as g, Do as _, Dr as v, Ds as y, Dt as b, E as x, Ea as S, Ec as C, Ei as w, En as T, Eo as E, Er as D, Es as O, Et as k, F as A, Fa as we, Fc as Te, Fi as Ee, Fn as De, Fo as Oe, Fr as ke, Fs as Ae, Ft as je, G as Me, Ga as Ne, Gc as Pe, Gi as Fe, Gn as Ie, Go as Le, Gr as Re, Gs as ze, Gt as Be, H as Ve, Ha as He, Hc as Ue, Hi as We, Hn as Ge, Ho as Ke, Hr as qe, Hs as Je, Ht as Ye, I as Xe, Ia as Ze, Ic as Qe, Ii as $e, In as et, Io as tt, Ir as nt, Is as rt, It as it, J as at, Ja as ot, Jc as st, Ji as ct, Jn as lt, Jo as ut, Jr as dt, Js as ft, Jt as pt, K as mt, Ka as ht, Kc as gt, Ki as _t, Kn as vt, Ko as yt, Kr as bt, Ks as xt, Kt as St, L as Ct, La as wt, Lc as Tt, Li as Et, Ln as Dt, Lo as Ot, Lr as kt, Ls as At, Lt as jt, M as Mt, Ma as Nt, Mc as Pt, Mi as Ft, Mn as It, Mo as Lt, Mr as Rt, Ms as zt, Mt as Bt, N as Vt, Na as Ht, Nc as Ut, Ni as Wt, Nn as Gt, No as Kt, Nr as qt, Ns as Jt, Nt as Yt, O as Xt, Oa as Zt, Oc as Qt, Oi as $t, On as en, Oo as tn, Or as nn, Os as rn, Ot as an, P as on, Pa as sn, Pc as cn, Pi as ln, Pn as un, Po as dn, Pr as fn, Ps as pn, Pt as mn, Q as hn, Qa as gn, Qc as _n, Qi as vn, Qn as yn, Qo as bn, Qr as xn, Qs as Sn, Qt as Cn, R as wn, Ra as Tn, Rc as En, Ri as Dn, Rn as On, Ro as kn, Rr as An, Rs as jn, Rt as Mn, S as Nn, Sa as Pn, Sc as Fn, Si as In, Sn as Ln, So as Rn, Sr as zn, Ss as Bn, St as Vn, T as Hn, Ta as Un, Tc as Wn, Ti as Gn, Tn as Kn, To as qn, Tr as Jn, Ts as Yn, Tt as Xn, U as Zn, Ua as Qn, Uc as $n, Ui as er, Un as tr, Uo as nr, Ur as rr, Us as ir, Ut as ar, V as or, Va as sr, Vc as cr, Vi as lr, Vn as ur, Vo as dr, Vr as fr, Vs as pr, Vt as mr, W as hr, Wa as gr, Wc as _r, Wi as vr, Wn as yr, Wo as br, Wr as xr, Ws as Sr, Wt as Cr, X as wr, Xa as Tr, Xc as Er, Xi as Dr, Xn as Or, Xo as kr, Xr as Ar, Xs as jr, Xt as Mr, Y as Nr, Ya as Pr, Yc as Fr, Yi as Ir, Yn as Lr, Yo as Rr, Yr as zr, Ys as Br, Yt as Vr, Z as Hr, Za as Ur, Zc as Wr, Zi as Gr, Zn as Kr, Zo as qr, Zr as Jr, Zs as Yr, Zt as Xr, _ as Zr, _a as Qr, _c as $r, _i as ei, _n as ti, _o as ni, _r as ri, _s as ii, _t as ai, a as oi, aa as si, ac as ci, ai as li, al as ui, an as di, ao as fi, ar as pi, as as mi, at as hi, b as gi, ba as _i, bc as vi, bi as yi, bn as bi, bo as xi, br as Si, bs as Ci, bt as wi, c as Ti, ca as Ei, cc as Di, ci as Oi, cl as ki, cn as Ai, co as ji, cr as Mi, cs as Ni, ct as Pi, d as Fi, da as Ii, dc as Li, di as Ri, dl as zi, dn as Bi, do as Vi, dr as Hi, ds as Ui, dt as Wi, ea as Gi, ec as Ki, ei as qi, el as Ji, en as Yi, eo as Xi, er as Zi, es as Qi, et as $i, f as ea, fa as ta, fc as na, fi as ra, fl as ia, fn as aa, fo as oa, fr as sa, fs as ca, ft as la, g as ua, ga as da, gc as fa, gi as pa, gl as ma, gn as ha, go as ga, gr as _a, gs as va, gt as ya, h as ba, ha as xa, hc as Sa, hi as Ca, hl as wa, hn as Ta, ho as Ea, hr as Da, hs as Oa, ht as ka, i as Aa, ia as ja, ic as Ma, ii as Na, il as Pa, in as Fa, io as Ia, ir as La, is as Ra, it as za, j as Ba, ja as Va, jc as Ha, ji as Ua, jn as Wa, jo as Ga, jr as Ka, js as qa, jt as Ja, k as Ya, ka as Xa, kc as Za, ki as Qa, kn as $a, ko as eo, kr as to, ks as no, kt as ro, l as io, la as ao, lc as oo, li as so, ll as co, ln as lo, lo as uo, lr as fo, ls as po, lt as mo, m as ho, ma as go, mc as _o, mi as vo, ml as yo, mn as bo, mo as xo, mr as So, ms as Co, mt as wo, n as To, na as Eo, nc as Do, ni as Oo, nl as ko, nn as Ao, no as jo, nr as Mo, ns as No, nt as Po, o as Fo, oa as Io, oc as Lo, oi as Ro, ol as zo, on as Bo, oo as Vo, or as Ho, os as Uo, ot as Wo, p as Go, pa as Ko, pc as qo, pi as Jo, pl as Yo, pn as Xo, po as Zo, pr as Qo, ps as $o, pt as es, q as ts, qa as ns, qc as rs, qi as is, qn as as, qo as os, qr as ss, qs as cs, qt as ls, r as us, ra as ds, rc as fs, ri as ps, rl as ms, rn as hs, ro as gs, rr as _s, rs as vs, rt as ys, s as bs, sa as xs, sc as Ss, si as Cs, sl as ws, sn as Ts, so as Es, sr as Ds, ss as Os, st as ks, t as As, ta as js, tc as Ms, ti as Ns, tl as Ps, tn as Fs, to as Is, tr as Ls, ts as Rs, tt as zs, u as Bs, ua as Vs, uc as Hs, ui as Us, ul as Ws, un as Gs, uo as Ks, ur as qs, us as Js, ut as Ys, v as Xs, va as Zs, vc as Qs, vi as $s, vn as ec, vo as tc, vr as nc, vs as rc, vt as ic, w as ac, wa as oc, wc as sc, wi as cc, wn as lc, wo as uc, wr as dc, ws as fc, wt as pc, x as mc, xa as hc, xc as gc, xi as _c, xn as vc, xo as yc, xr as bc, xs as xc, xt as Sc, y as Cc, ya as wc, yc as Tc, yi as Ec, yn as Dc, yo as Oc, yr as kc, ys as Ac, yt as jc, z as Mc, za as Nc, zc as Pc, zi as Fc, zn as Ic, zo as Lc, zr as Rc, zs as zc, zt as Bc } from "./apiUrls-2n3hzoxF.js";
import { $ as Vc, A as Hc, B as Uc, C as Wc, D as Gc, E as Kc, F as qc, G as Jc, H as Yc, I as Xc, J as Zc, K as Qc, L as j, M as $c, N as M, O as el, P as tl, Q as nl, R as rl, S as il, T as al, U as ol, V as N, W as sl, X as cl, Y as ll, Z as ul, _ as dl, a as fl, b as P, c as pl, d as ml, et as hl, f as gl, g as _l, h as vl, i as yl, j as bl, k as xl, l as Sl, m as Cl, n as F, o as wl, p as Tl, q as El, r as Dl, s as Ol, t as kl, tt as Al, u as jl, v as Ml, w as I, x as Nl, y as Pl, z as Fl } from "./types-BubWVBaU.js";
import { n as Il, r as Ll, t as Rl } from "./useShipmentPricingService-CiSffpk6.js";
import { DeliveryTypeName as L, PackageTypeId as zl, Weight as Bl, toCarrierNameV2 as Vl, toDeliveryTypeNameV2 as Hl, toPackageTypeNameV2 as R } from "@myparcel-frontend/types";
import { units as Ul } from "@myparcel-frontend/utils";
//#region src/generated/schemas.gen.ts
var Wl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_404_not_found" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_404_not_found" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, Gl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "User Error",
	type: "object",
	required: [
		"message",
		"request_id",
		"status_code",
		"errors"
	],
	additionalProperties: !1,
	properties: {
		message: { type: "string" },
		request_id: {
			type: "string",
			description: "Internal request ID, useful for debugging purposes."
		},
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error" },
		errors: {
			type: ["array", "object"],
			items: { $ref: "#/components/schemas/common_error_user" },
			additionalProperties: { $ref: "#/components/schemas/common_error_user" }
		}
	}
}, Kl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code - 4xx (Client Error)",
	description: "The request contains bad syntax or cannot be fulfilled",
	type: "integer",
	minimum: 400,
	maximum: 499
}, ql = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error" },
		code: { $ref: "#/components/schemas/common_error_user_code" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, Jl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	anyOf: [{ $ref: "#/components/schemas/common_error_user_code_auth" }, { type: "integer" }]
}, Yl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.error.user.code.Auth",
	description: "Authentication and Authorization related error codes",
	type: "integer",
	enum: [
		3e3,
		3001,
		3002,
		3003,
		3004,
		3005,
		3006,
		3007
	],
	oneOf: [
		{
			enum: [3e3],
			title: "AccessDenied",
			description: "Access Denied"
		},
		{
			enum: [3001],
			title: "PermissionDenied",
			description: "Permission Denied"
		},
		{
			enum: [3002],
			title: "SessionTokenNotFound",
			description: "Session Token Not Found"
		},
		{
			enum: [3003],
			title: "LastLoginAttemptFailed",
			description: "Last login attempt failed"
		},
		{
			enum: [3004],
			title: "MaxLoginAttemptsReached",
			description: "Max login attempts reached"
		},
		{
			enum: [3005],
			title: "SessionTokenInvalidated",
			description: "Session Token Invalidated"
		},
		{
			enum: [3006],
			title: "InvalidJwtToken",
			description: "Invalid JWT Token"
		},
		{
			enum: [3007],
			title: "UserNotFoundInAuthcontext",
			description: "User Not Found in Auth Context"
		}
	],
	"x-enum-varnames": [
		"AccessDenied",
		"PermissionDenied",
		"SessionTokenNotFound",
		"LastLoginAttemptFailed",
		"MaxLoginAttemptsReached",
		"SessionTokenInvalidated",
		"InvalidJwtToken",
		"UserNotFoundInAuthcontext"
	],
	"x-enum-descriptions": [
		"Access Denied",
		"Permission Denied",
		"Session Token Not Found",
		"Last login attempt failed",
		"Max login attempts reached",
		"Session Token Invalidated",
		"Invalid JWT Token",
		"User Not Found in Auth Context"
	]
}, Xl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [404],
	title: "Not Found",
	description: "Did not find the requested target resource."
}, Zl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			description: "A list of Shipment Resources.",
			items: { $ref: "#/components/schemas/shipment_defs_shipment" }
		} }
	} }
}, Ql = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment resource",
	required: /* @__PURE__ */ "id.parent_id.account_id.shop_id.shipment_type.recipient.sender.status.options.general_settings.pickup.customs_declaration.physical_properties.reference_identifier.transaction_status.drop_off_point.hidden.price.barcode.region.external_provider.external_provider_id.payment_status.carrier_id.platform_id.origin.user_agent.secondary_shipments.collection_contact.multi_collo_main_shipment_id.external_identifier.delayed.delivered.contract_id.created.modified.created_by.modified_by".split("."),
	properties: {
		id: {
			type: "integer",
			format: "int64",
			title: "Shipment ID",
			description: "Unique ID of a Shipment."
		},
		parent_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }] },
		account_id: { $ref: "#/components/schemas/account_defs_account_properties_id" },
		shop_id: { $ref: "#/components/schemas/account_defs_shop_properties_id" },
		shipment_type: { $ref: "#/components/schemas/_ref_shipment_type" },
		recipient: {
			allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_recipient" }],
			required: ["cc", "person"]
		},
		sender: { $ref: "#/components/schemas/shipment_defs_shipment_sender" },
		status: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
		options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
		general_settings: { $ref: "#/components/schemas/_ref_shipment_general_settings" },
		pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
		customs_declaration: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_shipment_customs_declaration" }] },
		physical_properties: { $ref: "#/components/schemas/shipment_defs_shipment_physical_properties" },
		reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" },
		transaction_status: { $ref: "#/components/schemas/_ref_shipment_transaction_status" },
		drop_off_point: { $ref: "#/components/schemas/shipment_defs_shipment_drop_off_point" },
		hidden: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		price: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		barcode: {
			type: "string",
			maxLength: 255
		},
		region: {
			type: "string",
			oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: ["Wereld"] }]
		},
		external_provider: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_display_name" }] },
		external_provider_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_id" }] },
		payment_status: { $ref: "#/components/schemas/shipment_defs_shipment_payment_status" },
		carrier_id: { $ref: "#/components/schemas/_ref_types_carrier" },
		platform_id: { $ref: "#/components/schemas/account_defs_platform_properties_id" },
		origin: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_origin" }] },
		user_agent: { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_user_agent" },
		secondary_shipments: {
			type: "array",
			items: {
				title: "Secondary Shipment resource",
				required: /* @__PURE__ */ "id.parent_id.account_id.shop_id.shipment_type.recipient.sender.status.options.general_settings.pickup.customs_declaration.physical_properties.reference_identifier.transaction_status.drop_off_point.hidden.price.barcode.region.external_provider.external_provider_id.payment_status.carrier_id.platform_id.origin.user_agent.collection_contact.multi_collo_main_shipment_id.external_identifier.delayed.delivered.contract_id.created.modified.created_by.modified_by".split("."),
				properties: {
					id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
					parent_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_parent_id" },
					account_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_account_id" },
					shop_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shop_id" },
					shipment_type: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shipment_type" },
					recipient: { $ref: "#/components/schemas/shipment_defs_shipment_properties_recipient" },
					sender: { $ref: "#/components/schemas/shipment_defs_shipment_properties_sender" },
					status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_status" },
					options: { $ref: "#/components/schemas/shipment_defs_shipment_properties_options" },
					general_settings: { $ref: "#/components/schemas/shipment_defs_shipment_properties_general_settings" },
					pickup: { $ref: "#/components/schemas/shipment_defs_shipment_properties_pickup" },
					customs_declaration: { $ref: "#/components/schemas/shipment_defs_shipment_properties_customs_declaration" },
					physical_properties: { $ref: "#/components/schemas/shipment_defs_shipment_properties_physical_properties" },
					reference_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_reference_identifier" },
					transaction_status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_transaction_status" },
					drop_off_point: { $ref: "#/components/schemas/shipment_defs_shipment_properties_drop_off_point" },
					hidden: { $ref: "#/components/schemas/shipment_defs_shipment_properties_hidden" },
					price: { $ref: "#/components/schemas/shipment_defs_shipment_properties_price" },
					barcode: { $ref: "#/components/schemas/shipment_defs_shipment_properties_barcode" },
					region: { $ref: "#/components/schemas/shipment_defs_shipment_properties_region" },
					external_provider: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_provider" },
					external_provider_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_provider_id" },
					payment_status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_payment_status" },
					carrier_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_carrier_id" },
					platform_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_platform_id" },
					origin: { $ref: "#/components/schemas/shipment_defs_shipment_properties_origin" },
					user_agent: { $ref: "#/components/schemas/shipment_defs_shipment_properties_user_agent" },
					secondary_shipments: {
						type: ["null", "array"],
						maxItems: 0
					},
					collection_contact: { $ref: "#/components/schemas/shipment_defs_shipment_properties_collection_contact" },
					multi_collo_main_shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_multi_collo_main_shipment_id" },
					external_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_identifier" },
					delayed: { $ref: "#/components/schemas/shipment_defs_shipment_properties_delayed" },
					delivered: { $ref: "#/components/schemas/shipment_defs_shipment_properties_delivered" },
					amount: { $ref: "#/components/schemas/shipment_defs_shipment_properties_amount" },
					currency: { $ref: "#/components/schemas/shipment_defs_shipment_properties_currency" },
					contract_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_contract_id" },
					link_consumer_portal: { $ref: "#/components/schemas/shipment_defs_shipment_properties_link_consumer_portal" },
					partner_tracktraces: { $ref: "#/components/schemas/shipment_defs_shipment_properties_partner_tracktraces" },
					pickup_request_number: { $ref: "#/components/schemas/shipment_defs_shipment_properties_pickup_request_number" },
					order_shipment_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_order_shipment_identifier" },
					shipped_items: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shipped_items" },
					created: { $ref: "#/components/schemas/shipment_defs_shipment_properties_created" },
					modified: { $ref: "#/components/schemas/shipment_defs_shipment_properties_modified" },
					created_by: { $ref: "#/components/schemas/shipment_defs_shipment_properties_created_by" },
					modified_by: { $ref: "#/components/schemas/shipment_defs_shipment_properties_modified_by" }
				},
				additionalProperties: !1
			}
		},
		collection_contact: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_contact" }] },
		multi_collo_main_shipment_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }] },
		external_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_carrier_properties_external_identifier" },
		delayed: {
			type: "boolean",
			default: !1
		},
		delivered: {
			type: "boolean",
			default: !1
		},
		amount: {
			type: ["integer", "null"],
			format: "int32"
		},
		currency: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/billing_defs_currency" }] },
		contract_id: {
			type: ["integer", "null"],
			format: "int64"
		},
		link_consumer_portal: {
			type: ["null", "string"],
			oneOf: [{ format: "uri" }, { enum: [""] }]
		},
		partner_tracktraces: { $ref: "#/components/schemas/shipment_defs_shipment_partner_tracktraces" },
		pickup_request_number: { type: ["null", "string"] },
		order_shipment_identifier: {
			type: ["null", "string"],
			format: "uuid",
			maxLength: 36
		},
		shipped_items: {
			type: ["null", "array"],
			items: { $ref: "#/components/schemas/shipment_defs_shipment_shipped_item" }
		},
		created: { $ref: "#/components/schemas/common_defs_timestamps_properties_created" },
		modified: { $ref: "#/components/schemas/common_defs_timestamps_properties_modified" },
		created_by: { $ref: "#/components/schemas/common_defs_timestamps_properties_created_by" },
		modified_by: { $ref: "#/components/schemas/common_defs_timestamps_properties_modified_by" }
	},
	additionalProperties: !1
}, $l = {
	type: "integer",
	format: "int64",
	title: "Shipment ID",
	description: "Unique ID of a Shipment.",
	$schema: "http://json-schema.org/draft-04/schema#"
}, eu = {
	title: "Account ID",
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, tu = {
	title: "Shop ID",
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, nu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.Type",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8
	],
	oneOf: [
		{
			enum: [1],
			title: "Standard"
		},
		{
			enum: [2],
			title: "Return"
		},
		{
			enum: [3],
			title: "MultiCollo"
		},
		{
			enum: [4],
			title: "LabelPackage"
		},
		{
			enum: [5],
			title: "ReturnErs"
		},
		{
			enum: [6],
			title: "ReturnSpecial"
		},
		{
			enum: [7],
			title: "Express"
		},
		{
			enum: [8],
			title: "Fulfilment"
		}
	],
	"x-enum-varnames": [
		"Standard",
		"Return",
		"MultiCollo",
		"LabelPackage",
		"ReturnErs",
		"ReturnSpecial",
		"Express",
		"Fulfilment"
	]
}, ru = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Recipient",
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_sender" }],
	properties: {
		person: { maxLength: 50 },
		first_name: {
			type: "string",
			maxLength: 50
		},
		last_name: {
			type: "string",
			maxLength: 50
		},
		company: { maxLength: 50 },
		street: {
			maxLength: 40,
			minLength: 1,
			pattern: "\\D+"
		},
		street_additional_info: { maxLength: 50 },
		number: { maxLength: 8 },
		number_suffix: { maxLength: 6 },
		postal_code: { maxLength: 10 },
		city: {
			maxLength: 35,
			minLength: 1
		},
		state: { maxLength: 2 },
		area: { maxLength: 35 },
		phone: { maxLength: 25 }
	}
}, iu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Sender",
	type: "object",
	required: ["cc"],
	additionalProperties: !1,
	properties: {
		account_id: { $ref: "#/components/schemas/account_defs_account_properties_id" },
		person: { type: "string" },
		first_name: { type: "string" },
		last_name: { type: "string" },
		company: { type: ["null", "string"] },
		street: { type: "string" },
		street_additional_info: { type: ["null", "string"] },
		number: { type: ["null", "string"] },
		number_suffix: { type: ["null", "string"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		state: { type: "string" },
		cc: { $ref: "#/components/schemas/_ref_types_cc" },
		region: {
			type: ["null", "string"],
			maxLength: 35
		},
		area: { type: "string" },
		phone: { type: ["null", "string"] },
		email: {
			type: ["null", "string"],
			anyOf: [{ format: "email" }, { enum: [null, ""] }]
		},
		billing_email: { $ref: "#/components/schemas/account_defs_contact_properties_email" },
		secondary_emails: {
			type: ["null", "array"],
			items: { $ref: "#/components/schemas/shipment_defs_shipment_sender_properties_email" }
		},
		box_number: {
			type: ["null", "string"],
			maxLength: 8
		},
		eori_number: { type: "string" },
		vat_number: { type: "string" },
		invalid: { type: "boolean" }
	}
}, au = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	maxLength: 2,
	minLength: 2,
	pattern: "^[A-Za-z]{2}$"
}, ou = {
	type: ["null", "string"],
	maxLength: 255,
	anyOf: [{ enum: [null, ""] }, { format: "email" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, su = {
	type: ["null", "string"],
	anyOf: [{ format: "email" }, { enum: [null, ""] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, cu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.shipment.Status",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		98,
		99,
		100,
		101,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38
	],
	oneOf: [
		{
			enum: [1],
			title: "PendingConcept",
			description: "Pending - Concept\n\nThe Shipment is a concept and not yet registered at the carrier.\n"
		},
		{
			enum: [2],
			title: "PendingRegistered",
			description: "Pending - Registered\n\nThe Shipment has been registered with the carrier, and has been assigned a Track & Trace code.\n"
		},
		{
			enum: [3],
			title: "EnrouteHandedToCarrier",
			description: "En Route - Handed to Carrier\n\nThe Shipment has been handed to the carrier for transport.\n"
		},
		{
			enum: [4],
			title: "EnrouteSorting",
			description: "En Route - Sorting\n\nThe Shipment is being sorted at the carrier's sorting facility.\n"
		},
		{
			enum: [5],
			title: "EnrouteDistribution",
			description: "En Route - Distribution\n\nThe Shipment is being distributed by the carrier to the recipient's address.\n"
		},
		{
			enum: [6],
			title: "DeliveredAtCustoms",
			description: "En Route - Customs\n\nThe Shipment is being processed by customs.\n"
		},
		{
			enum: [7],
			title: "Delivered",
			description: "Delivered - At Recipient\n\nThe Shipment has been delivered to the recipient.\n"
		},
		{
			enum: [8],
			title: "InPickupLocation",
			description: "Delivered - Ready for Pickup\n\nThe Shipment is ready for pickup at a pickup location.\n"
		},
		{
			enum: [9],
			title: "PickedUp",
			description: "Delivered - Picked Up\n\nThe Shipment has been picked up by the recipient at a pickup location.\n"
		},
		{
			enum: [10],
			title: "ReturnShipmentDelivered",
			description: "Delivered - Return Shipment Ready for Pickup\n\nThe Return Shipment is ready to be picked at a pickup location.\n"
		},
		{
			enum: [11],
			title: "ReturnShipmentInPickupLocation",
			description: "Delivered - Return Shipment Picked Up\n\nThe Return Shipment has been picked up by the recipient at a pickup location.\n"
		},
		{
			enum: [12],
			title: "PrintedUnpaidLabel",
			description: "Printed - Unpaid Label\n\nThe label has been printed without postage paid.\n"
		},
		{
			enum: [13],
			title: "Credit",
			description: "Credited\n\nThe Shipment has been credited.\n"
		},
		{
			enum: [14],
			title: "PrintedStamp",
			description: "Printed - Digital Stamp\n\nThe Shipment has been printed with a digital stamp.\n"
		},
		{
			enum: [15],
			title: "PrintedExternalShipment",
			description: "Printed - External Shipment\n\nThe Shipment has been printed with an External Shipment.\n"
		},
		{
			enum: [16],
			title: "Expired",
			description: "Expired\n\nThe Shipment has expired.\n"
		},
		{
			enum: [17],
			title: "Cancelled",
			description: "Cancelled\n\nThe Shipment has been cancelled.\n"
		},
		{
			enum: [18],
			title: "PrintedUntrackedShipment",
			description: "Printed - Untracked Shipment\n\nThe Shipment has been printed with an untracked Shipment.\n"
		},
		{
			enum: [19],
			title: "DeliveredAtAgreedLocation",
			description: "Delivered - At Agreed Location\n\nThe Shipment has been delivered at a privately agreed location.\n"
		},
		{
			enum: [98],
			title: "Inactive",
			description: "Inactive\n\nThe Shipment is inactive.\n"
		},
		{
			enum: [99],
			title: "Deleted",
			description: "Deleted\n\nThe Shipment has been deleted.\n"
		},
		{
			enum: [100],
			title: "CreditRejected",
			description: "Credit - Rejected\n\nThe credit request for the Shipment was rejected.\n"
		},
		{
			enum: [101],
			title: "CreditApproved",
			description: "Credit - Approved\n\nThe credit request for the Shipment was approved.\n"
		},
		{
			enum: [30],
			title: "LegacyPendingConcept",
			description: "(legacy) Pending - Concept"
		},
		{
			enum: [31],
			title: "LegacyPendingRegistered",
			description: "(legacy) Pending - Registered"
		},
		{
			enum: [32],
			title: "LegacyEnrouteHandedToCarrier",
			description: "(legacy) En Route - Handed to Carrier"
		},
		{
			enum: [33],
			title: "LegacyEnrouteSorting",
			description: "(legacy) En Route - Sorting"
		},
		{
			enum: [34],
			title: "LegacyEnrouteDistribution",
			description: "(legacy) En Route - Distribution"
		},
		{
			enum: [35],
			title: "LegacyDeliveredAtCustoms",
			description: "(legacy) En Route - Customs"
		},
		{
			enum: [36],
			title: "LegacyDelivered",
			description: "(legacy) Delivered - At Recipient"
		},
		{
			enum: [37],
			title: "LegacyInPickupLocation",
			description: "(legacy) Delivered - Ready for Pickup"
		},
		{
			enum: [38],
			title: "LegacyPickedUp",
			description: "(legacy) Delivered - Picked Up"
		}
	],
	"x-enum-varnames": /* @__PURE__ */ "PendingConcept.PendingRegistered.EnrouteHandedToCarrier.EnrouteSorting.EnrouteDistribution.DeliveredAtCustoms.Delivered.InPickupLocation.PickedUp.ReturnShipmentDelivered.ReturnShipmentInPickupLocation.PrintedUnpaidLabel.Credit.PrintedStamp.PrintedExternalShipment.Expired.Cancelled.PrintedUntrackedShipment.DeliveredAtAgreedLocation.Inactive.Deleted.CreditRejected.CreditApproved.LegacyPendingConcept.LegacyPendingRegistered.LegacyEnrouteHandedToCarrier.LegacyEnrouteSorting.LegacyEnrouteDistribution.LegacyDeliveredAtCustoms.LegacyDelivered.LegacyInPickupLocation.LegacyPickedUp".split("."),
	"x-enum-descriptions": [
		"The Shipment is a concept and not yet registered at the carrier.",
		"The Shipment has been registered with the carrier, and has been assigned a Track & Trace code.",
		"The Shipment has been handed to the carrier for transport.",
		"The Shipment is being sorted at the carrier's sorting facility.",
		"The Shipment is being distributed by the carrier to the recipient's address",
		"The Shipment is being processed by customs.",
		"The Shipment has been delivered to the recipient.",
		"The Shipment is ready for pickup at a pickup location.",
		"The Shipment has been picked up by the recipient at a pickup location.",
		"The Return Shipment is ready to be picked at a pickup location.",
		"The Return Shipment has been picked up by the recipient at a pickup location.",
		"The label has been printed without postage paid.",
		"The Shipment has been credited.",
		"The Shipment label has been printed as a digital stamp.",
		"A Shipment label has been printed for an External Shipment.",
		"The Shipment has expired.",
		"The Shipment has been canceled.",
		"The Shipment has been printed with an untracked Shipment.",
		"The Shipment has been delivered at a privately agreed location - e.g. in front of the door, under a bush, etc.",
		"The Shipment is inactive.",
		"The Shipment has been deleted.",
		"The credit request for the Shipment was rejected."
	]
}, lu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	allOf: [
		{ $ref: "#/components/schemas/_ref_shipment_options_insurance_max" },
		{ $ref: "#/components/schemas/_ref_shipment_options_options" },
		{ $ref: "#/components/schemas/_ref_shipment_options_package_type_all" },
		{ $ref: "#/components/schemas/_ref_shipment_options_delivery_type_all" },
		{ $ref: "#/components/schemas/_ref_shipment_options_delivery_type_delivery_date" },
		{ $ref: "#/components/schemas/_ref_shipment_options_label_description" }
	]
}, uu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	allOf: [{ $ref: "#/components/schemas/_ref_shipment_options_insurance" }],
	properties: { insurance: { properties: { amount: { maximum: 25e5 } } } }
}, du = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { insurance: {
		$comment: "insurance currency must be EUR because shipment carriers expect this",
		$ref: "#/components/schemas/_ref_types_price_euro"
	} }
}, fu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Price with EUR-currency and amount",
	type: "object",
	additionalProperties: !1,
	required: ["amount", "currency"],
	properties: {
		currency: {
			type: "string",
			enum: ["EUR"]
		},
		amount: {
			minimum: 0,
			type: "integer"
		}
	}
}, pu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cash_on_delivery: { $ref: "#/components/schemas/_ref_types_money" },
		collect: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		extra_assurance: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		fresh_food: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		frozen: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		hide_sender: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		large_format: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		no_tracking: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		only_recipient: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		priority_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		receipt_code: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		return: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		signature: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		tracked: {
			description: "DEPRECATED: replaced by no_tracking (its inverse).",
			$ref: "#/components/schemas/_ref_types_int_boolean"
		}
	}
}, mu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.IntBoolean",
	type: "number",
	enum: [0, 1],
	"x-enum-varnames": ["False", "True"]
}, hu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Money",
	description: "Money amount with currency",
	type: "object",
	required: ["currency", "amount"],
	additionalProperties: !1,
	properties: {
		currency: {
			description: "The currency as uppercase 3-letter ISO 4217 code.",
			type: "string",
			enum: ["", "EUR"]
		},
		amount: {
			description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
			oneOf: [{
				type: "integer",
				minimum: 0
			}, {
				type: ["string"],
				pattern: "\\d*"
			}]
		}
	}
}, gu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" } }
}, _u = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.PackageType",
	description: "Package Type.",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	],
	oneOf: [
		{
			enum: [1],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: [2],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: [3],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: [4],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: [5],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: [6],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: [7],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, vu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { delivery_type: {
		type: ["integer", "null"],
		enum: [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			null
		]
	} }
}, yu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { delivery_date: {
		type: ["string", "null"],
		pattern: "([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})"
	} }
}, bu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { label_description: {
		type: ["null", "string"],
		maxLength: 45
	} }
}, xu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["object", "null"],
	properties: {
		save_recipient_address: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		delivery_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		delivery_notification_email: {
			type: "array",
			items: {
				type: "string",
				format: "email"
			}
		},
		disable_auto_detect_pickup: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		printer_identifier: { type: "string" },
		tracktrace: {
			type: "object",
			properties: {
				bcc: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				bcc_email: { $ref: "#/components/schemas/account_defs_contact_properties_email" },
				carrier_email_basic_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				delivery_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				delivery_notification_email: {
					type: "array",
					items: { type: "string" }
				},
				disable_auto_detect_pickup: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				email_on_handed_to_courier: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				from_address_company: { type: "string" },
				from_address_email: {
					type: "string",
					anyOf: [{ format: "email" }, { enum: [""] }]
				},
				printer_identifier: { type: "string" },
				save_recipient_address: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				send_track_trace_emails: { $ref: "#/components/schemas/_ref_types_int_boolean" }
			}
		}
	},
	additionalProperties: !1
}, Su = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Pickup Location",
	type: ["null", "object"],
	additionalProperties: !1,
	properties: {
		location_code: { type: "string" },
		location_name: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["null", "string"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		cc: {
			type: "string",
			maxLength: 2,
			minLength: 2,
			pattern: "^[A-Z]{2}"
		},
		location_type: { oneOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { $ref: "#/components/schemas/_ref_shipment_bpost_bpost_pugo_type" }] },
		retail_network_id: { type: "string" }
	}
}, Cu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Pickup / drop-off location type.",
	type: "string",
	enum: [
		"retail",
		"locker",
		"post_office"
	],
	oneOf: [
		{
			enum: ["retail"],
			title: "Retail",
			description: "Shops/postal points."
		},
		{
			enum: ["locker"],
			title: "Locker",
			description: "Automated parcel locker."
		},
		{
			enum: ["post_office"],
			title: "PostOffice",
			description: "Post office location."
		}
	],
	"x-enum-varnames": [
		"Retail",
		"Locker",
		"PostOffice"
	]
}, wu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.bpost.BpostPugoType",
	type: "integer",
	enum: [
		0,
		1,
		2,
		4,
		8,
		16
	],
	oneOf: [
		{
			enum: [0],
			title: "Unknown"
		},
		{
			enum: [1],
			title: "PostOffice"
		},
		{
			enum: [2],
			title: "PostPoint"
		},
		{
			enum: [4],
			title: "ParcelLocker"
		},
		{
			enum: [8],
			title: "ClickCollect"
		},
		{
			enum: [16],
			title: "ParcelPoint"
		}
	],
	"x-enum-varnames": [
		"Unknown",
		"PostOffice",
		"PostPoint",
		"ParcelLocker",
		"ClickCollect",
		"ParcelPoint"
	]
}, Tu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.CustomsDeclaration",
	type: ["object"],
	required: [
		"contents",
		"weight",
		"items"
	],
	properties: {
		contents: { $ref: "#/components/schemas/shipment_defs_customs_shipment_type" },
		invoice: {
			type: ["string", "null"],
			maxLength: 150
		},
		eori_number: { type: ["string", "null"] },
		vat_number: { type: ["string", "null"] },
		vat_number_uk: { type: ["string", "null"] },
		voec_number: { type: ["string", "null"] },
		weight: {
			type: "integer",
			minimum: 0,
			maximum: 999999999
		},
		items: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: { $ref: "#/components/schemas/_ref_shipment_customs_declaration_item" }
		}
	},
	additionalProperties: !1
}, Eu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CustomsShipmentType",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5
	],
	oneOf: [
		{
			enum: [1],
			title: "CommercialGoods"
		},
		{
			enum: [2],
			title: "CommercialSample"
		},
		{
			enum: [3],
			title: "Documents"
		},
		{
			enum: [4],
			title: "Gift"
		},
		{
			enum: [5],
			title: "ReturnedGoods"
		}
	],
	"x-enum-varnames": [
		"CommercialGoods",
		"CommercialSample",
		"Documents",
		"Gift",
		"ReturnedGoods"
	]
}, Du = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"description",
		"amount",
		"weight",
		"item_value",
		"classification"
	],
	properties: {
		description: {
			type: "string",
			maxLength: 50
		},
		amount: {
			type: "integer",
			minimum: 1,
			maximum: 99999
		},
		weight: {
			type: "integer",
			minimum: 0,
			maximum: 999999999
		},
		item_value: { $ref: "#/components/schemas/_ref_types_money" },
		classification: { type: "string" },
		country: {
			type: "string",
			oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: [""] }]
		}
	},
	additionalProperties: !1
}, Ou = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Physical Properties",
	type: ["null", "object"],
	properties: {
		weight: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_weight" },
		height: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_height" }, { type: "null" }] },
		width: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_width" }, { type: "null" }] },
		length: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_length" }, { type: "null" }] },
		volume: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_volume" }, { type: "null" }] },
		carrier_weight: { anyOf: [
			{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_weight" },
			{
				type: "string",
				pattern: "^\\d+$"
			},
			{ type: "null" }
		] },
		carrier_height: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_height" }, { type: "null" }] },
		carrier_width: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_width" }, { type: "null" }] },
		carrier_length: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_length" }, { type: "null" }] },
		carrier_volume: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_volume" }, { type: "null" }] }
	},
	additionalProperties: !1
}, ku = {
	type: "integer",
	format: "int32",
	minimum: 0,
	maximum: 999999999,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Au = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, ju = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Mu = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Nu = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Pu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_weight"
}, Fu = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_height" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Iu = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_width" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Lu = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_length" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ru = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_volume" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, zu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Reference Identifier",
	description: "Arbitrary reference identifier that can be used to identify a shipment.",
	type: [
		"null",
		"integer",
		"string"
	],
	maxLength: 255,
	pattern: "^[^=\\?]*$"
}, Bu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["null", "string"],
	enum: [
		null,
		"pending",
		"unpaid",
		"paid"
	]
}, Vu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Drop-Off Point",
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_pickup" }],
	required: [
		"location_code",
		"location_name",
		"street",
		"number",
		"postal_code",
		"city"
	]
}, Hu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "MoneyNullableAmount",
	description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS).",
	type: "object",
	required: ["currency", "amount"],
	additionalProperties: !1,
	properties: {
		currency: { $ref: "#/components/schemas/_ref_types_money_properties_currency" },
		amount: {
			description: "The amount in the lowest denomination of the currency (e.g. cents for EUR), or null when the requester may not read price amounts.",
			oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_types_money_properties_amount" }]
		}
	}
}, Uu = {
	description: "The currency as uppercase 3-letter ISO 4217 code.",
	type: "string",
	enum: ["", "EUR"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Wu = {
	description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
	oneOf: [{
		type: "integer",
		minimum: 0
	}, {
		type: ["string"],
		pattern: "\\d*"
	}],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Gu = {
	title: "External Provider Display Name",
	type: "string",
	enum: [
		"Facebook",
		"Flespakket.nl",
		"Amazon",
		"Bol.com",
		"MyParcel.nl",
		"Wix",
		"Ecwid",
		"Exact Online DE",
		"Exact Online NL",
		"Etsy"
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ku = {
	title: "External Provider ID",
	type: "integer",
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, qu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Payment Status",
	type: ["null", "string"],
	enum: [
		null,
		"pending",
		"unpaid",
		"paid"
	]
}, Ju = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.Carrier",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: [1]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: [2]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: [3]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: [4]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: [5]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: [6]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: [7]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: [8]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: [9]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: [10]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: [11]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: [12]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: [13]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: [14]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: [15]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: [16]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: [17]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: [18]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: [19]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: [20]
		},
		{
			description: "DHL Freight",
			title: "DhlFreight",
			enum: [21]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim",
		"DhlFreight"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"Via Tim",
		"DHL Freight"
	]
}, Yu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_platform_id"
}, Xu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.defs.PlatformId",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6
	],
	oneOf: [
		{
			enum: [1],
			title: "myparcel"
		},
		{
			enum: [2],
			title: "flespakket"
		},
		{
			enum: [3],
			title: "belgie"
		},
		{
			enum: [4],
			title: "delivery_dutch"
		},
		{
			enum: [5],
			title: "postnl_customer"
		},
		{
			enum: [6],
			title: "italy"
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, Zu = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Qu = {
	type: ["null", "string"],
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, $u = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, ed = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_account_properties_id"
}, td = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_shop_properties_id"
}, nd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_type"
}, rd = {
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_recipient" }],
	required: ["cc", "person"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, id = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_sender"
}, ad = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_status"
}, od = {
	allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, sd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_general_settings"
}, cd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_pickup"
}, ld = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_shipment_customs_declaration" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, ud = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_physical_properties"
}, dd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_reference_identifier"
}, fd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_transaction_status"
}, pd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_drop_off_point"
}, md = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_int_boolean"
}, hd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_money_nullable_amount"
}, gd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, _d = {
	type: "string",
	oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: ["Wereld"] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, vd = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_display_name" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, yd = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, bd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_payment_status"
}, xd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_carrier"
}, Sd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_platform_properties_id"
}, Cd = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_origin" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, wd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_origin_properties_user_agent"
}, Td = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_contact" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ed = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Contact",
	type: "object",
	required: [
		"last_name",
		"email",
		"phone",
		"company",
		"street",
		"number",
		"postal_code",
		"city",
		"cc"
	],
	additionalProperties: !1,
	properties: {
		id: {
			type: ["integer"],
			format: "int32"
		},
		gender: {
			type: ["null", "string"],
			maxLength: 3
		},
		first_name: {
			type: ["null", "string"],
			maxLength: 255
		},
		last_name: {
			type: ["null", "string"],
			maxLength: 255
		},
		email: {
			type: ["null", "string"],
			maxLength: 255,
			anyOf: [{ enum: [null, ""] }, { format: "email" }]
		},
		phone: {
			type: ["null", "string"],
			maxLength: 100
		},
		company: {
			type: ["null", "string"],
			maxLength: 255
		},
		street: { $ref: "#/components/schemas/account_defs_location_properties_street" },
		street_additional_info: { $ref: "#/components/schemas/account_defs_location_properties_street_additional_info" },
		number: { $ref: "#/components/schemas/account_defs_location_properties_number" },
		number_suffix: { $ref: "#/components/schemas/account_defs_location_properties_number_suffix" },
		postal_code: { $ref: "#/components/schemas/account_defs_location_properties_postal_code" },
		city: { $ref: "#/components/schemas/account_defs_location_properties_city" },
		cc: { $ref: "#/components/schemas/account_defs_location_properties_cc" },
		region: { $ref: "#/components/schemas/account_defs_location_properties_region" },
		box_number: { $ref: "#/components/schemas/account_defs_location_properties_box_number" }
	}
}, Dd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Od = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, kd = {
	type: ["string", "integer"],
	pattern: "\\d+",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ad = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, jd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Md = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Nd = {
	type: "string",
	pattern: "^[A-Z][A-Z]$",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Pd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Fd = {
	type: ["null", "string"],
	maxLength: 8,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Id = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ld = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_carrier_properties_external_identifier"
}, Rd = {
	title: "Shipment Carrier External Identifier",
	type: ["null", "string"],
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, zd = {
	type: "boolean",
	default: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Bd = {
	type: "boolean",
	default: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Vd = {
	type: ["integer", "null"],
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Hd = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/billing_defs_currency" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ud = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Currency",
	type: "string",
	maxLength: 3,
	enum: ["", "EUR"]
}, Wd = {
	type: ["integer", "null"],
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Gd = {
	type: ["null", "string"],
	oneOf: [{ format: "uri" }, { enum: [""] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Kd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_partner_tracktraces"
}, qd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Partner Track & Traces",
	type: "array",
	items: {
		type: "object",
		required: ["uri", "barcode"],
		properties: {
			uri: {
				type: "string",
				anyOf: [{ enum: [""] }, { format: "uri" }]
			},
			barcode: { type: "string" }
		}
	}
}, Jd = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Yd = {
	type: ["null", "string"],
	format: "uuid",
	maxLength: 36,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Xd = {
	type: ["null", "array"],
	items: { $ref: "#/components/schemas/shipment_defs_shipment_shipped_item" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Zd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipped Item",
	type: ["null", "object"],
	properties: {
		quantity: { $ref: "#/components/schemas/order_defs_shipped_item_properties_quantity" },
		order_line_identifier: { $ref: "#/components/schemas/order_defs_shipped_item_properties_order_line_identifier" },
		order_line: { $ref: "#/components/schemas/order_defs_shipped_item_properties_order_line" },
		picklist_identifier: { $ref: "#/components/schemas/order_defs_shipped_item_properties_picklist_identifier" },
		order_identifier: { type: ["null", "string"] }
	},
	additionalProperties: !1
}, Qd = {
	type: ["null", "integer"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, $d = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, ef = {
	type: ["null", "object"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, tf = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, nf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_created"
}, rf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_date_and_time"
}, af = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.DateAndTime",
	description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n",
	type: "string",
	pattern: "\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\\d|3[0-1]) ([0-1]\\d|2[0-4]):[0-5]\\d(:([0-5]\\d|60)(.\\d+)?)?"
}, of = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_modified"
}, sf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_date_and_time"
}, cf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_created_by"
}, lf = {
	anyOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_user_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, uf = {
	title: "User ID",
	type: "integer",
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, df = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_modified_by"
}, ff = {
	anyOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_user_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, pf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	format: "binary",
	anyOf: [{ contentMediaType: "application/pdf" }, { contentMediaType: "application/vnd.zpl" }]
}, mf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Download URL",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		oneOf: [
			{
				required: ["pdf"],
				additionalProperties: !1,
				properties: { pdf: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["pdfs"],
				additionalProperties: !1,
				properties: { pdfs: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["csvs"],
				additionalProperties: !1,
				properties: { csvs: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["zpl"],
				additionalProperties: !1,
				properties: { zpl: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["zpls"],
				additionalProperties: !1,
				properties: { zpls: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			}
		]
	} },
	definitions: { url: {
		type: "object",
		required: ["url"],
		additionalProperties: !1,
		properties: { url: {
			type: "string",
			format: "uri"
		} }
	} }
}, hf = {
	type: "object",
	required: ["url"],
	additionalProperties: !1,
	properties: { url: {
		type: "string",
		format: "uri"
	} },
	$schema: "http://json-schema.org/draft-04/schema#"
}, gf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: { shipments: {
			type: "object",
			required: ["unpaid_shipments", "blocked_shipments"],
			additionalProperties: !1,
			properties: {
				unpaid_shipments: { $ref: "#/components/schemas/billing_defs_shipment_data" },
				blocked_shipments: { $ref: "#/components/schemas/billing_defs_shipment_data" }
			}
		} }
	} }
}, _f = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "array",
	items: {
		type: "object",
		required: [
			"shipment_id",
			"price",
			"price_after_vat"
		],
		additionalProperties: !1,
		properties: {
			shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
			price: { $ref: "#/components/schemas/_ref_types_money" },
			price_after_vat: { $ref: "#/components/schemas/_ref_types_money" }
		}
	}
}, vf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Payment Instructions",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["payment_instructions"],
		properties: { payment_instructions: {
			type: "array",
			items: { $ref: "#/components/schemas/billing_defs_payment_data" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, yf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Payment Data",
	type: "object",
	required: [
		"id",
		"hash",
		"type",
		"notification_hash",
		"original_notification_hash",
		"paid",
		"price",
		"payment_url",
		"invoices"
	],
	properties: {
		id: { type: "string" },
		hash: { type: "string" },
		type: { type: "integer" },
		notification_hash: { type: "string" },
		original_notification_hash: { type: "string" },
		paid: {
			type: "integer",
			enum: [0, 1]
		},
		price: { $ref: "#/components/schemas/common_defs_price" },
		payment_url: {
			type: ["string", "null"],
			format: "uri"
		},
		invoices: {
			type: "object",
			required: [
				"id",
				"number",
				"status"
			],
			properties: {
				id: { type: "integer" },
				number: { type: "string" },
				status: { type: "integer" }
			},
			additionalProperties: !1
		}
	},
	additionalProperties: !1
}, bf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Price",
	description: "Price amount in a specific currency",
	type: "object",
	required: ["amount", "currency"],
	properties: {
		amount: {
			description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
			type: ["integer", "null"]
		},
		currency: {
			description: "The currency as uppercase 3-letter ISO 4217 code.",
			type: "string",
			enum: ["", "EUR"]
		}
	},
	additionalProperties: !1
}, xf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Bad Request",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_400_bad_request" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_400_bad_request" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, Sf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [400],
	title: "Bad Request",
	description: "The server will not process the request due to a client error."
}, Cf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Problem Details (RFC 9457)",
	description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n",
	type: "object",
	required: [
		"type",
		"title",
		"status",
		"detail"
	],
	properties: {
		type: {
			type: "string",
			description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n"
		},
		title: {
			type: "string",
			description: "A short, human-readable summary of the problem type."
		},
		status: {
			type: "integer",
			description: "The HTTP status code for this occurrence."
		},
		detail: {
			type: "string",
			description: "A human-readable explanation specific to this occurrence."
		},
		instance: {
			type: "string",
			description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n"
		},
		request_id: {
			type: "string",
			description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n"
		},
		errors: {
			type: "array",
			description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n",
			items: {
				type: "object",
				required: [
					"type",
					"title",
					"detail"
				],
				properties: {
					type: { type: "string" },
					title: { type: "string" },
					detail: { type: "string" },
					instance: { type: "string" }
				}
			}
		}
	}
}, wf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DeliveryOptionsV2",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["deliveries"],
		properties: { deliveries: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_option-v2" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Tf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_option.DeliveryOptionV2",
	type: "object",
	required: ["date", "possibilities"],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date_time" },
		possibilities: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_possibility" }
		}
	},
	additionalProperties: !1
}, Ef = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.DateTime",
	type: "object",
	required: [
		"date",
		"timezone",
		"timezone_type"
	],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date_and_time" },
		timezone: { type: "string" },
		timezone_type: { $ref: "#/components/schemas/common_defs_time_zone_type" }
	}
}, Df = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.TimeZoneType",
	type: "integer",
	enum: [
		0,
		1,
		2,
		3
	],
	oneOf: [
		{
			enum: [0],
			title: "None"
		},
		{
			enum: [1],
			title: "Offset",
			description: "A UTC offset, such as `+01:00`\n"
		},
		{
			enum: [2],
			title: "Abbreviation",
			description: "A timezone abbreviation, such as `CET`\n"
		},
		{
			enum: [3],
			title: "Identifier",
			description: "A timezone identifier, such as `Europe/Amsterdam`\n"
		}
	],
	"x-enum-varnames": [
		"None",
		"Offset",
		"Abbreviation",
		"Identifier"
	],
	"x-enum-descriptions": [
		"None",
		"A UTC offset, such as `+01:00`",
		"A timezone abbreviation, such as `CET`",
		"A timezone identifier, such as `Europe/Amsterdam`"
	]
}, Of = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryPossibility",
	type: "object",
	required: [
		"type",
		"package_type",
		"delivery_time_frames",
		"shipment_options"
	],
	properties: {
		type: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_delivery_options_delivery_name-v2" }, { type: "null" }] },
		package_type: { $ref: "#/components/schemas/shipment_responses_delivery_options_package_type-v2" },
		delivery_time_frames: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_delivery_options_delivery_time_frame" }
		},
		shipment_options: {
			type: "array",
			items: {
				type: "object",
				required: ["name", "schema"],
				properties: {
					name: { type: "string" },
					schema: {
						type: "object",
						required: ["type", "enum"],
						properties: {
							type: { enum: ["boolean"] },
							enum: {
								type: "array",
								items: { type: "boolean" }
							}
						},
						additionalProperties: !1
					}
				},
				additionalProperties: !1
			}
		},
		price: { $ref: "#/components/schemas/common_defs_price" },
		identifier: { type: "string" },
		transporter: { type: "string" },
		label_type: { type: "string" }
	},
	additionalProperties: !1
}, kf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryNameV2",
	type: "string",
	enum: [
		"morning",
		"standard",
		"evening",
		"same_day",
		"express",
		"early_morning"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["morning"]
		},
		{
			title: "Standard",
			enum: ["standard"]
		},
		{
			title: "Evening",
			enum: ["evening"]
		},
		{
			title: "SameDay",
			enum: ["same_day"]
		},
		{
			title: "Express",
			enum: ["express"]
		},
		{
			title: "EarlyMorning",
			enum: ["early_morning"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Af = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.delivery_options.PackageTypeV2",
	description: "Package Type.",
	type: "string",
	enum: [
		"package",
		"mailbox",
		"unfranked",
		"digital_stamp",
		"pallet",
		"small_package",
		"envelope"
	],
	oneOf: [
		{
			enum: ["package"],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: ["mailbox"],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: ["unfranked"],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: ["digital_stamp"],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: ["pallet"],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: ["small_package"],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: ["envelope"],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, jf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryTimeFrame",
	type: "object",
	required: ["type", "date_time"],
	properties: {
		type: { enum: ["start", "end"] },
		date_time: { $ref: "#/components/schemas/common_defs_date_time" }
	},
	additionalProperties: !1
}, Mf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DeliveryOptionsV1",
	type: "object",
	required: ["data"],
	properties: {
		data: {
			type: "object",
			required: ["delivery", "pickup"],
			properties: {
				delivery: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_option-v1" }
				},
				pickup: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_defs_delivery_options_pickup" }
				},
				message: { type: "string" }
			},
			additionalProperties: !1
		},
		errors: {
			type: "array",
			items: { anyOf: [{ $ref: "#/components/schemas/error" }, {
				type: "object",
				required: ["code", "message"],
				properties: {
					code: { type: "integer" },
					message: { type: "string" },
					human: { type: "string" }
				},
				additionalProperties: !1
			}] }
		}
	},
	additionalProperties: !1
}, Nf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryOptionV1",
	type: "object",
	required: ["date", "time"],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date" },
		time: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_time" }
		}
	},
	additionalProperties: !1
}, Pf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Date",
	description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n",
	type: "string",
	format: "date",
	pattern: "\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\\d|3[0-1])"
}, Ff = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryTime",
	type: "object",
	required: [
		"start",
		"end",
		"price",
		"price_comment",
		"comment",
		"type"
	],
	properties: {
		start: { $ref: "#/components/schemas/common_defs_time" },
		end: { $ref: "#/components/schemas/common_defs_time" },
		price: { $ref: "#/components/schemas/common_defs_price" },
		price_comment: { type: "string" },
		comment: { type: "string" },
		type: { type: "integer" },
		collect_date: { $ref: "#/components/schemas/common_defs_date_time" },
		identifier: { type: "string" },
		transporter: { type: "string" },
		label_type: { type: "string" }
	},
	additionalProperties: !1
}, If = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Time",
	description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n",
	type: "string",
	format: "time",
	pattern: "([0-1]\\d|2[0-4]):[0-5]\\d(:([0-5]\\d|60)(.\\d+)?)?"
}, Lf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.Pickup",
	type: "object",
	properties: {
		date: { anyOf: [{ $ref: "#/components/schemas/common_defs_date" }, { type: "null" }] },
		time: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_delivery_options_pickup_time" }
		},
		location: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		cc: { type: "string" },
		start_time: { anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }] },
		price: { type: "integer" },
		price_comment: {
			type: "string",
			enum: ["retail", "retailexpress"]
		},
		comment: { type: "string" },
		phone_number: { type: "string" },
		opening_hours: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours" },
		distance: { type: "string" },
		latitude: { $ref: "#/components/schemas/common_defs_latitude" },
		longitude: { $ref: "#/components/schemas/common_defs_longitude" },
		location_code: { type: "string" },
		retail_network_id: { type: ["string", "null"] },
		holiday: {
			type: "object",
			properties: {
				from: { type: ["string", "null"] },
				to: { type: ["string", "null"] }
			},
			additionalProperties: !1
		}
	},
	additionalProperties: !1
}, Rf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.PickupTime",
	type: "object",
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }] },
		type: { $ref: "#/components/schemas/_ref_types_delivery_type" },
		price: { $ref: "#/components/schemas/common_defs_price" }
	}
}, zf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.DeliveryType",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		6,
		7,
		8
	],
	oneOf: [
		{
			title: "Morning",
			enum: [1]
		},
		{
			title: "Standard",
			enum: [2]
		},
		{
			title: "Evening",
			enum: [3]
		},
		{
			title: "Pickup",
			enum: [4]
		},
		{
			title: "SameDay",
			enum: [6]
		},
		{
			title: "Express",
			enum: [7]
		},
		{
			title: "EarlyMorning",
			enum: [8]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Bf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.OpeningHours",
	type: "object",
	required: [
		"monday",
		"tuesday",
		"wednesday",
		"thursday",
		"friday",
		"saturday",
		"sunday"
	],
	properties: {
		monday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		tuesday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		wednesday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		thursday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		friday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		saturday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		sunday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" }
	},
	additionalProperties: !1,
	definitions: { opening_hours: {
		description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n",
		type: "array",
		items: { type: "string" }
	} }
}, Vf = {
	description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n",
	type: "array",
	items: { type: "string" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Hf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Latitude",
	type: ["number", "string"],
	minimum: -90,
	maximum: 90,
	pattern: "^[-+]?(90|[0-8]?\\d)(\\.\\d+)?$"
}, Uf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Longitude",
	type: ["number", "string"],
	minimum: -180,
	maximum: 180,
	pattern: "^[-+]?(180|(0?\\d{0,2}|1[0-7]\\d)(\\.\\d+)?)$"
}, Wf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["code", "message"],
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_error" },
		code: { $ref: "#/components/schemas/common_error_user_code" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, Gf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code: Error",
	type: "integer",
	anyOf: [{ $ref: "#/components/schemas/common_http_status_code_4xx_client_error" }, { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" }]
}, Kf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code - 5xx (Server Error)",
	description: "The server failed to fulfill an apparently valid request",
	type: "integer",
	minimum: 500,
	maximum: 599
}, qf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_406_not_acceptable" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_406_not_acceptable" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, Jf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [406],
	title: "Not Acceptable",
	description: "The target resource doesn't have an acceptable representation for the user agent."
}, Yf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Download URL",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["download_url"],
		properties: { download_url: { $ref: "#/components/schemas/common_defs_download_url" } },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Xf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "DownloadUrl",
	description: "DownloadUrl Object Definition",
	required: ["link"],
	properties: { link: {
		type: "string",
		format: "uri"
	} },
	additionalProperties: !1
}, Zf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DropOffPoints",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["drop_off_points"],
		properties: { drop_off_points: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_drop_off_point" }
		} },
		additionalProperties: !1
	} }
}, Qf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DropOffPoint",
	type: "object",
	properties: {
		location_code: { type: "string" },
		location_name: { type: ["string", "null"] },
		cc: { type: "string" },
		state: { type: ["string", "null"] },
		city: { type: "string" },
		postal_code: { type: "string" },
		street: { type: "string" },
		number: { type: [
			"string",
			"integer",
			"null"
		] },
		number_suffix: { type: ["string", "null"] },
		phone: { type: ["string", "null"] },
		reference: { type: ["string", "null"] },
		longitude: { anyOf: [{ $ref: "#/components/schemas/common_defs_longitude" }, { type: "null" }] },
		latitude: { anyOf: [{ $ref: "#/components/schemas/common_defs_latitude" }, { type: "null" }] },
		available_days: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_available_days" },
		cut_off_time: { type: ["string", "null"] },
		carrier_id: { $ref: "#/components/schemas/_ref_types_carrier" },
		distance: { type: ["number", "null"] },
		occupancy: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_occupancy" }, { type: "null" }] },
		occupancy_today: { type: ["number", "null"] },
		default_drop_off_point: { type: ["boolean", "null"] },
		type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { type: "null" }] },
		opening_hours: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_opening_hours" }
	},
	definitions: {
		available_days: {
			type: ["array", "null"],
			items: { anyOf: [{ $ref: "#/components/schemas/common_defs_day_of_week" }, { $ref: "#/components/schemas/common_defs_iso_day_of_week" }] }
		},
		opening_hours: {
			type: ["object", "null"],
			properties: {
				monday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				tuesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				wednesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				thursday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				friday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				saturday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				sunday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" }
			},
			additionalProperties: !1
		},
		timeframes: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframe" }
		},
		timeframe: {
			type: "object",
			required: ["start", "end"],
			properties: {
				start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
				end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
			},
			additionalProperties: !1
		}
	}
}, $f = {
	type: ["array", "null"],
	items: { anyOf: [{ $ref: "#/components/schemas/common_defs_day_of_week" }, { $ref: "#/components/schemas/common_defs_iso_day_of_week" }] },
	$schema: "http://json-schema.org/draft-04/schema#"
}, ep = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "commopn.defs.DayOfWeek",
	type: "integer",
	enum: [
		0,
		1,
		2,
		3,
		4,
		5,
		6
	],
	oneOf: [
		{
			enum: [0],
			title: "Sunday"
		},
		{
			enum: [1],
			title: "Monday"
		},
		{
			enum: [2],
			title: "Tuesday"
		},
		{
			enum: [3],
			title: "Wednesday"
		},
		{
			enum: [4],
			title: "Thursday"
		},
		{
			enum: [5],
			title: "Friday"
		},
		{
			enum: [6],
			title: "Saturday"
		}
	],
	"x-enum-varnames": [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	]
}, tp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "commopn.defs.IsoDayOfWeek",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	],
	oneOf: [
		{
			enum: [1],
			title: "Monday"
		},
		{
			enum: [2],
			title: "Tuesday"
		},
		{
			enum: [3],
			title: "Wednesday"
		},
		{
			enum: [4],
			title: "Thursday"
		},
		{
			enum: [5],
			title: "Friday"
		},
		{
			enum: [6],
			title: "Saturday"
		},
		{
			enum: [7],
			title: "Sunday"
		}
	],
	"x-enum-varnames": [
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
		"Sunday"
	]
}, np = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.Occupancy",
	type: "object",
	properties: {
		monday: { type: ["number", "null"] },
		tuesday: { type: ["number", "null"] },
		wednesday: { type: ["number", "null"] },
		thursday: { type: ["number", "null"] },
		friday: { type: ["number", "null"] },
		saturday: { type: ["number", "null"] },
		sunday: { type: ["number", "null"] }
	}
}, rp = {
	type: ["object", "null"],
	properties: {
		monday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		tuesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		wednesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		thursday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		friday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		saturday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		sunday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, ip = {
	type: "array",
	items: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframe" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, ap = {
	type: "object",
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, op = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_415_unsupported_media_type" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_415_unsupported_media_type" },
					code: { enum: [3100] }
				}
			}
		}
	} }]
}, sp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [415],
	title: "Unsupported Media Type",
	description: "Content is in a format not supported by this method on the target resource."
}, cp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_401_unauthorized" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_401_unauthorized" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, lp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [401],
	title: "Unauthorized",
	description: "The request lacks valid authentication credentials for the target resource."
}, up = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.PickupLocations",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["pickup_locations"],
		properties: { pickup_locations: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_pickup_location" }
		} },
		additionalProperties: !1
	} },
	definitions: {
		pickup_location: {
			type: "object",
			required: [
				"address",
				"possibilities",
				"location"
			],
			properties: {
				address: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_address" },
				possibilities: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_possibilities" },
				location: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_location" }
			},
			additionalProperties: !1
		},
		address: {
			type: "object",
			required: [
				"cc",
				"city",
				"street",
				"postal_code",
				"number"
			],
			properties: {
				cc: { type: "string" },
				city: { type: "string" },
				street: { type: "string" },
				postal_code: { type: "string" },
				number: { type: "string" },
				number_suffix: { type: ["string", "null"] }
			},
			additionalProperties: !1
		},
		possibilities: {
			type: "array",
			items: {
				type: "object",
				required: [
					"delivery_type_id",
					"delivery_type_name",
					"price",
					"moment"
				],
				properties: {
					delivery_type_id: { type: "integer" },
					delivery_type_name: { type: "string" },
					price: { type: "integer" },
					moment: {
						type: "object",
						properties: { start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] } }
					}
				},
				additionalProperties: !1
			}
		},
		location: {
			type: "object",
			required: [
				"location_name",
				"retail_network_id",
				"distance",
				"latitude",
				"longitude",
				"location_code",
				"phone_number",
				"type",
				"opening_hours"
			],
			properties: {
				location_name: { type: "string" },
				retail_network_id: { type: ["string", "null"] },
				distance: { type: "string" },
				latitude: { type: "string" },
				longitude: { type: "string" },
				location_code: { type: "string" },
				phone_number: { type: ["string", "null"] },
				type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { type: "null" }] },
				opening_hours: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_opening_hours" }
			},
			additionalProperties: !1
		},
		opening_hours: {
			type: "object",
			required: [
				"monday",
				"tuesday",
				"wednesday",
				"thursday",
				"friday",
				"saturday",
				"sunday"
			],
			properties: {
				monday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				tuesday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				wednesday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				thursday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				friday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				saturday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				sunday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				}
			},
			additionalProperties: !1
		},
		timeframe: {
			type: "object",
			required: ["start", "end"],
			properties: {
				start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
				end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
			},
			additionalProperties: !1
		}
	}
}, dp = {
	type: "object",
	required: [
		"address",
		"possibilities",
		"location"
	],
	properties: {
		address: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_address" },
		possibilities: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_possibilities" },
		location: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_location" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, fp = {
	type: "object",
	required: [
		"cc",
		"city",
		"street",
		"postal_code",
		"number"
	],
	properties: {
		cc: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		postal_code: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, pp = {
	type: "array",
	items: {
		type: "object",
		required: [
			"delivery_type_id",
			"delivery_type_name",
			"price",
			"moment"
		],
		properties: {
			delivery_type_id: { type: "integer" },
			delivery_type_name: { type: "string" },
			price: { type: "integer" },
			moment: {
				type: "object",
				properties: { start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] } }
			}
		},
		additionalProperties: !1
	},
	$schema: "http://json-schema.org/draft-04/schema#"
}, mp = {
	type: "object",
	required: [
		"location_name",
		"retail_network_id",
		"distance",
		"latitude",
		"longitude",
		"location_code",
		"phone_number",
		"type",
		"opening_hours"
	],
	properties: {
		location_name: { type: "string" },
		retail_network_id: { type: ["string", "null"] },
		distance: { type: "string" },
		latitude: { type: "string" },
		longitude: { type: "string" },
		location_code: { type: "string" },
		phone_number: { type: ["string", "null"] },
		type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { type: "null" }] },
		opening_hours: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_opening_hours" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, hp = {
	type: "object",
	required: [
		"monday",
		"tuesday",
		"wednesday",
		"thursday",
		"friday",
		"saturday",
		"sunday"
	],
	properties: {
		monday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		tuesday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		wednesday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		thursday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		friday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		saturday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		sunday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		}
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, gp = {
	type: "object",
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, _p = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: {
			shipments: {
				type: "array",
				description: "A list of Shipment Resources.",
				items: { $ref: "#/components/schemas/shipment_defs_shipment" }
			},
			pdf: {
				type: "object",
				required: ["url"],
				additionalProperties: !1,
				properties: { url: {
					type: "string",
					format: "uri-reference",
					pattern: "^/pdfs/.*"
				} }
			},
			zpl: {
				type: "object",
				required: ["url"],
				additionalProperties: !1,
				properties: { url: {
					type: "string",
					format: "uri-reference",
					pattern: "^/zpls/.*"
				} }
			}
		}
	} }
}, vp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["ids"],
		additionalProperties: !1,
		properties: { ids: {
			type: "array",
			description: "A list of Shipment IDs.",
			items: {
				type: "object",
				required: ["id", "reference_identifier"],
				additionalProperties: !1,
				properties: {
					id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
					reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" }
				}
			}
		} }
	} }
}, yp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		oneOf: [{
			required: ["ids", "pdf"],
			additionalProperties: !1,
			properties: {
				ids: { $ref: "#/components/schemas/shipment_responses_shipment_ids_properties_data_properties_ids" },
				pdf: {
					type: "object",
					required: ["url"],
					additionalProperties: !1,
					properties: { url: {
						type: "string",
						format: "uri-reference",
						pattern: "^/pdfs/.*"
					} }
				}
			}
		}, {
			required: ["ids", "zpl"],
			additionalProperties: !1,
			properties: {
				ids: { $ref: "#/components/schemas/shipment_responses_shipment_ids_properties_data_properties_ids" },
				zpl: {
					type: "object",
					required: ["url"],
					additionalProperties: !1,
					properties: { url: {
						type: "string",
						format: "uri-reference",
						pattern: "^/zpls/.*"
					} }
				}
			}
		}]
	} }
}, bp = {
	type: "array",
	description: "A list of Shipment IDs.",
	items: {
		type: "object",
		required: ["id", "reference_identifier"],
		additionalProperties: !1,
		properties: {
			id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
			reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" }
		}
	},
	$schema: "http://json-schema.org/draft-04/schema#"
}, xp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "System Error",
	type: "object",
	properties: {
		message: {
			type: "string",
			description: "A human-readable description of the error."
		},
		request_id: {
			type: "string",
			description: "Internal request ID, useful for debugging purposes."
		},
		status_code: { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" },
		errors: {
			type: "array",
			items: { $ref: "#/components/schemas/common_error_system" }
		}
	}
}, Sp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" },
		code: { type: "integer" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, Cp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["shipments", "results"],
		properties: {
			shipments: {
				type: "array",
				description: "A list of Shipment Resources.",
				items: { $ref: "#/components/schemas/shipment_defs_shipment" }
			},
			results: {
				type: "integer",
				description: "The number of results."
			}
		},
		additionalProperties: !1
	} },
	additionalProperties: !1
}, wp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.TrackTraces",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["tracktraces"],
		properties: { tracktraces: {
			type: "array",
			description: "A list of Track & Trace Resources.",
			items: { $ref: "#/components/schemas/shipment_defs_track_trace" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Tp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackTrace",
	description: "A Track & Trace resource.",
	type: "object",
	required: [
		"shipment_id",
		"carrier",
		"code",
		"description",
		"time",
		"link_consumer_portal",
		"link_tracktrace",
		"partner_tracktraces",
		"recipient",
		"sender",
		"options",
		"pickup",
		"delayed",
		"location",
		"status",
		"history"
	],
	properties: {
		shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
		carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
		code: { type: "string" },
		description: { type: "string" },
		time: { $ref: "#/components/schemas/common_defs_date_and_time" },
		link_consumer_portal: {
			type: ["string", "null"],
			format: "uri"
		},
		link_tracktrace: {
			type: ["string", "null"],
			format: "uri"
		},
		partner_tracktraces: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_external_track_trace_link" }
		},
		recipient: { $ref: "#/components/schemas/shipment_defs_shipment_recipient" },
		sender: { $ref: "#/components/schemas/shipment_defs_shipment_sender" },
		options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
		pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
		delayed: { type: "boolean" },
		location: { $ref: "#/components/schemas/shipment_defs_tracking_location" },
		status: {
			type: "object",
			required: [
				"current",
				"main",
				"final"
			],
			properties: {
				current: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
				main: { $ref: "#/components/schemas/shipment_defs_main_status" },
				final: { type: "boolean" }
			},
			additionalProperties: !1
		},
		history: { $ref: "#/components/schemas/shipment_defs_carrier_track_trace_history" },
		delivery_moment_type: { $ref: "#/components/schemas/shipment_defs_delivery_moment_properties_type" },
		delivery_moment: { $ref: "#/components/schemas/shipment_defs_delivery_moment_properties_time_frame" },
		signature: { $ref: "#/components/schemas/shipment_defs_track_trace_proof_of_delivery" },
		returnable: { type: "boolean" }
	},
	additionalProperties: !1
}, Ep = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.ExternalTrackTraceLink",
	type: "object",
	required: ["uri", "barcode"],
	properties: {
		uri: {
			type: "string",
			format: "uri"
		},
		barcode: { type: "string" }
	},
	additionalProperties: !1
}, Dp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackingLocation",
	required: [
		"name",
		"cc",
		"city",
		"postal_code",
		"street",
		"number",
		"number_suffix",
		"longitude",
		"latitude"
	],
	properties: {
		name: { type: ["string"] },
		cc: { type: ["string", "null"] },
		city: { type: ["string", "null"] },
		postal_code: { type: ["string", "null"] },
		street: { type: ["string", "null"] },
		number: { type: ["string", "null"] },
		number_suffix: { type: ["string", "null"] },
		longitude: { type: ["number", "null"] },
		latitude: { type: ["number", "null"] }
	},
	additionalProperties: !1
}, Op = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.MainStatus",
	type: ["string", "null"],
	enum: [
		"registered",
		"handed_to_carrier",
		"sorting",
		"distribution",
		"delivered",
		null
	]
}, kp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CarrierTrackTraceHistory",
	type: "array",
	items: { $ref: "#/components/schemas/shipment_defs_carrier_track_trace_event" }
}, Ap = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CarrierTrackTraceEvent",
	type: "object",
	required: [
		"code",
		"status",
		"main",
		"description",
		"time",
		"delayed",
		"location"
	],
	properties: {
		code: { type: "string" },
		status: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_status" }] },
		main: { $ref: "#/components/schemas/shipment_defs_main_status" },
		description: { type: "string" },
		time: { $ref: "#/components/schemas/common_defs_date_and_time" },
		delayed: { type: "boolean" },
		location: { $ref: "#/components/schemas/shipment_defs_tracking_location" }
	},
	additionalProperties: !1
}, jp = {
	type: ["string", "null"],
	enum: [
		"estimated",
		"expected",
		null
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Mp = {
	type: ["object", "null"],
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Np = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackTraceProofOfDelivery",
	anyOf: [
		{ type: "null" },
		{
			type: "string",
			format: "base64"
		},
		{
			type: "object",
			required: ["content", "content_type"],
			properties: {
				content: { type: "string" },
				content_type: { type: "string" }
			},
			additionalProperties: !1
		}
	]
}, Pp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		description: "A list of V2 Capabilities for a given Shipment configuration.",
		items: { $ref: "#/components/schemas/_ref_capabilities_response_capability-v2" }
	} },
	additionalProperties: !1
}, Fp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"collo",
		"deliveryTypes",
		"packageTypes",
		"physicalProperties",
		"options",
		"transactionTypes"
	],
	additionalProperties: !1,
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		contract: { $ref: "#/components/schemas/_ref_capabilities_shared_contract-v2" },
		packageTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_response_options_options-v2" },
		physicalProperties: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_properties-v2" },
		deliveryTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" }
		},
		transactionTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, Ip = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ref.capabilities.shared.CarrierV2",
	description: "Carrier string definition for capabilities endpoints (v2)",
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_FREIGHT",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTE_ITALIANE",
		"POSTNL",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	],
	oneOf: [
		{
			description: "bpost",
			title: "Bpost",
			enum: ["BPOST"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["BRT"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["CHEAP_CARGO"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["DHL_EUROPLUS"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["DHL_FOR_YOU"]
		},
		{
			description: "DHL Freight",
			title: "DhlFreight",
			enum: ["DHL_FREIGHT"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["DHL_PARCEL_CONNECT"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["DPD"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["GLS"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["INPOST"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["POSTE_ITALIANE"]
		},
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["POSTNL"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["SPRING"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["TRUNKRS"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["UPS_EXPRESS_SAVER"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["UPS_STANDARD"]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: ["VIA_TIM"]
		}
	],
	"x-enum-varnames": [
		"Bpost",
		"Brt",
		"CheapCargo",
		"DhlEuroplus",
		"DhlForYou",
		"DhlFreight",
		"DhlParcelConnect",
		"Dpd",
		"Gls",
		"Inpost",
		"PosteItaliane",
		"Postnl",
		"Spring",
		"Trunkrs",
		"UpsExpressSaver",
		"UpsStandard",
		"ViaTim"
	],
	"x-enum-descriptions": [
		"bpost",
		"BRT",
		"Cheap Cargo",
		"DHL Europlus",
		"DHL For You",
		"DHL Freight",
		"DHL Parcel Connect",
		"DPD",
		"GLS",
		"InPost",
		"PosteItaliane",
		"PostNL",
		"Spring",
		"Trunkrs",
		"UPS Express Saver",
		"UPS Standard",
		"Via Tim"
	]
}, Lp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Contract definition for capabilities endpoints (v2)",
	type: "object",
	required: ["id", "type"],
	additionalProperties: !1,
	properties: {
		id: {
			type: "integer",
			format: "int32",
			description: "The contract ID."
		},
		type: {
			type: "string",
			enum: ["MAIN", "CUSTOM"],
			description: "The type of contract."
		}
	}
}, Rp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.PackageTypeV2",
	description: "Package Type.",
	type: "string",
	enum: [
		"PACKAGE",
		"MAILBOX",
		"UNFRANKED",
		"DIGITAL_STAMP",
		"PALLET",
		"SMALL_PACKAGE",
		"ENVELOPE"
	],
	oneOf: [
		{
			enum: ["PACKAGE"],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: ["MAILBOX"],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: ["UNFRANKED"],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: ["DIGITAL_STAMP"],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: ["PALLET"],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: ["SMALL_PACKAGE"],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: ["ENVELOPE"],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, zp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v2" }, {
		type: "object",
		properties: {
			additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			freshFood: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			frozen: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			hideSender: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_insurance_option-v2" },
			noTracking: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" }
		}
	}]
}, Bp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		freshFood: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		frozen: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		hideSender: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		noTracking: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		tracked: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }
	}
}, Vp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["isSelectedByDefault", "isRequired"],
	properties: {
		isSelectedByDefault: { type: "boolean" },
		isRequired: { type: "boolean" }
	}
}, Hp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }, {
		type: "object",
		required: ["requires", "excludes"],
		properties: {
			requires: {
				type: "array",
				items: { type: "string" },
				description: "camelCase shipment option keys that are required"
			},
			excludes: {
				type: "array",
				items: { type: "string" },
				description: "camelCase shipment option keys that are excluded"
			}
		}
	}]
}, Up = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v2" }]
}, Wp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		insuredAmount: {
			type: "object",
			required: [
				"default",
				"min",
				"max"
			],
			additionalProperties: !1,
			description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n",
			properties: {
				default: { $ref: "#/components/schemas/_ref_types_money" },
				min: { $ref: "#/components/schemas/_ref_types_money" },
				max: { $ref: "#/components/schemas/_ref_types_money" }
			}
		},
		default: { $ref: "#/components/schemas/_ref_types_money" },
		min: { $ref: "#/components/schemas/_ref_types_money" },
		max: { $ref: "#/components/schemas/_ref_types_money" }
	}
}, Gp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		width: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		height: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		girth: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volumetricWeight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volume: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		lengthWidthHeightSum: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" }
	}
}, Kp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"min",
		"max",
		"calculation"
	],
	additionalProperties: !1,
	properties: {
		min: { $ref: "#/components/schemas/_ref_types_value_with_unit" },
		max: { $ref: "#/components/schemas/_ref_types_value_with_unit" },
		calculation: { type: "string" }
	}
}, qp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["value", "unit"],
	additionalProperties: !1,
	properties: {
		value: {
			type: "number",
			description: "The numeric value"
		},
		unit: {
			type: "string",
			enum: [
				"g",
				"kg",
				"cm",
				"mm",
				"mm3",
				"cm3",
				"dm3",
				"m3"
			],
			description: "The unit of measurement in SI units"
		}
	}
}, Jp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.DeliveryTypeV2",
	type: "string",
	enum: [
		"MORNING_DELIVERY",
		"STANDARD_DELIVERY",
		"EVENING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["MORNING_DELIVERY"]
		},
		{
			title: "Standard",
			enum: ["STANDARD_DELIVERY"]
		},
		{
			title: "Evening",
			enum: ["EVENING_DELIVERY"]
		},
		{
			title: "Pickup",
			enum: ["PICKUP_DELIVERY"]
		},
		{
			title: "SameDay",
			enum: ["SAME_DAY_DELIVERY"]
		},
		{
			title: "Express",
			enum: ["EXPRESS_DELIVERY"]
		},
		{
			title: "EarlyMorning",
			enum: ["EARLY_MORNING_DELIVERY"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Yp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	enum: ["B2B", "B2C"]
}, Xp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["max"],
	additionalProperties: !1,
	properties: { max: { type: "integer" } }
}, Zp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["capabilities"],
		properties: { capabilities: {
			type: "array",
			description: "A list of V1 Capabilities for a given Shipment configuration.",
			items: { $ref: "#/components/schemas/_ref_capabilities_response_capability-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Qp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"collo",
		"delivery_types",
		"package_types",
		"physical_properties",
		"options",
		"transaction_types"
	],
	additionalProperties: !1,
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		contract: { $ref: "#/components/schemas/_ref_capabilities_shared_contract-v1" },
		package_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_response_options_options-v1" },
		physical_properties: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_properties-v1" },
		delivery_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type" }
		},
		transaction_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, $p = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ref.capabilities.shared.Carrier",
	description: "Carrier ID definition for capabilities endpoints (v1)",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: [1]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: [2]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: [3]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: [4]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: [9]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: [10]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: [11]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: [12]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: [13]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: [14]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: [15]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: [16]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: [17]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: [18]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: [19]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: [20]
		},
		{
			description: "DHL Freight",
			title: "DhlFreight",
			enum: [21]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim",
		"DhlFreight"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"Via Tim",
		"DHL Freight"
	]
}, em = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Contract definition for capabilities endpoints (v1)",
	type: "object",
	required: ["id", "type"],
	additionalProperties: !1,
	properties: {
		id: {
			type: "integer",
			format: "int32",
			description: "The contract ID."
		},
		type: {
			type: "string",
			enum: ["main", "custom"],
			description: "The type of contract."
		}
	}
}, tm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v1" }, {
		type: "object",
		properties: {
			age_check: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			collect: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			fresh_food: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			frozen: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			hide_sender: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_insurance_option-v1" },
			large_format: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			no_tracking: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			only_recipient: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			printerless_return: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			receipt_code: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			return: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			signature: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" }
		}
	}]
}, nm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		collect: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		fresh_food: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		frozen: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		hide_sender: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		large_format: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		no_tracking: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		only_recipient: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		printerless_return: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		receipt_code: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		return: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		signature: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		tracked: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }
	}
}, rm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["is_selected_by_default", "is_required"],
	properties: {
		is_selected_by_default: { type: "boolean" },
		is_required: { type: "boolean" }
	}
}, im = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }, {
		type: "object",
		required: ["requires", "excludes"],
		properties: {
			requires: {
				type: "array",
				items: { type: "string" },
				description: "snake_case shipment option keys that are required"
			},
			excludes: {
				type: "array",
				items: { type: "string" },
				description: "snake_case shipment option keys that are excluded"
			}
		}
	}]
}, am = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v1" }]
}, om = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		insured_amount: {
			type: "object",
			required: [
				"default",
				"min",
				"max"
			],
			additionalProperties: !1,
			description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n",
			properties: {
				default: { $ref: "#/components/schemas/_ref_types_money" },
				min: { $ref: "#/components/schemas/_ref_types_money" },
				max: { $ref: "#/components/schemas/_ref_types_money" }
			}
		},
		default: { $ref: "#/components/schemas/_ref_types_money" },
		min: { $ref: "#/components/schemas/_ref_types_money" },
		max: { $ref: "#/components/schemas/_ref_types_money" }
	}
}, sm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		width: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		height: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		girth: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volumetric_weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volume: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length_width_height_sum: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" }
	}
}, cm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["items"],
	properties: { items: {
		type: "array",
		description: "A superset of V2 Capabilities for the contracts within a user's account.",
		items: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_contract-definitions-v2" }
	} },
	additionalProperties: !1
}, lm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"collo",
		"deliveryTypes",
		"packageTypes",
		"options",
		"transactionTypes"
	],
	additionalProperties: !1,
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_options-v2" },
		deliveryTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" }
		},
		transactionTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, um = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v2" }, {
		type: "object",
		properties: {
			additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			hideSender: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_insurance_option-v2" },
			noTracking: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" }
		}
	}]
}, dm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }, {
		type: "object",
		additionalProperties: !1
	}]
}, fm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v2" }]
}, pm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["contract_definitions"],
		properties: { contract_definitions: {
			type: "array",
			description: "A superset of V1 Capabilities for the contracts within a user's account.",
			items: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_contract-definitions-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, mm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Capability contract definitions response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"collo",
		"delivery_types",
		"package_types",
		"options",
		"transaction_types"
	],
	additionalProperties: !1,
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		package_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_options-v1" },
		delivery_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type" }
		},
		transaction_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, hm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v1" }, {
		type: "object",
		properties: {
			age_check: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			collect: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			hide_sender: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_insurance_option-v1" },
			large_format: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			no_tracking: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			only_recipient: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			printerless_return: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			receipt_code: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			return: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			signature: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" }
		}
	}]
}, gm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }, {
		type: "object",
		additionalProperties: !1
	}]
}, _m = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v1" }]
}, vm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Rate response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"packageType",
		"shipmentType",
		"priceComposition"
	],
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		contract: { $ref: "#/components/schemas/_ref_rates_response_contract-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		deliveryType: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" },
		shipmentType: { $ref: "#/components/schemas/_ref_shipment_shipment_type-v2" },
		priceComposition: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price_composition-v2" }
	},
	additionalProperties: !1
}, ym = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The contract object.",
	type: "object",
	required: ["id", "type"],
	properties: {
		id: {
			type: "integer",
			description: "The id of the contract."
		},
		type: {
			type: "string",
			enum: ["MAIN", "CUSTOM"],
			description: "The type of contract."
		}
	},
	additionalProperties: !1
}, bm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	enum: [
		"EXPRESS",
		"FULFILMENT",
		"LABEL_PACKAGE",
		"MULTI_COLLO",
		"RETURN",
		"RETURN_ERS",
		"RETURN_SPECIAL",
		"STANDARD"
	]
}, xm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The V2 price composition object, containing the base, options, charges, discounts and total prices.",
	type: "object",
	required: [
		"base",
		"charges",
		"discounts",
		"options",
		"other",
		"total"
	],
	properties: {
		base: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" },
		charges: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		discounts: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		options: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		other: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		total: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
	},
	additionalProperties: !1
}, Sm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Price object.",
	type: "object",
	required: [
		"name",
		"key",
		"price",
		"vat",
		"priceWithVat"
	],
	properties: {
		name: { type: "string" },
		key: { type: "string" },
		price: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		vat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		priceWithVat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" }
	},
	additionalProperties: !1
}, Cm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["rates"],
		properties: { rates: {
			type: "array",
			description: "A list of V1 Rates for a given Shipment configuration.",
			items: { $ref: "#/components/schemas/_ref_rates_response_rate-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, wm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Rate response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"package_type",
		"shipment_type",
		"price_composition"
	],
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		contract: { $ref: "#/components/schemas/_ref_rates_response_contract" },
		package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" },
		delivery_type: { $ref: "#/components/schemas/_ref_types_delivery_type" },
		shipment_type: { $ref: "#/components/schemas/_ref_types_shipment_type" },
		price_composition: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price_composition-v1" }
	},
	additionalProperties: !1
}, Tm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The contract object.",
	type: "object",
	required: ["id", "type"],
	properties: {
		id: {
			type: "integer",
			description: "The id of the contract."
		},
		type: {
			type: "string",
			enum: ["main", "custom"],
			description: "The type of contract."
		}
	},
	additionalProperties: !1
}, Em = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	]
}, Dm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The price composition object, containing the base, options, charges, discounts and total prices.",
	type: "object",
	required: [
		"base",
		"charges",
		"discounts",
		"options",
		"other",
		"total"
	],
	properties: {
		base: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" },
		charges: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		discounts: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		options: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		other: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		total: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
	},
	additionalProperties: !1
}, Om = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Price object.",
	type: "object",
	required: [
		"name",
		"key",
		"price",
		"vat",
		"price_with_vat"
	],
	properties: {
		name: { type: "string" },
		key: { type: "string" },
		price: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		vat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		price_with_vat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" }
	},
	additionalProperties: !1
}, km = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		items: { $ref: "#/components/schemas/_ref_notification_response_notification_group" }
	} },
	additionalProperties: !1
}, Am = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Notification Group response item",
	type: "object",
	required: [
		"id",
		"shopId",
		"packageType",
		"countryCode",
		"shipmentDirection",
		"fallback"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		shopId: { type: "integer" },
		packageType: {
			type: ["string", "null"],
			enum: [
				"DIGITAL_STAMP",
				"ENVELOPE",
				"UNFRANKED",
				"MAILBOX",
				"PACKAGE",
				"PALLET",
				"SMALL_PACKAGE",
				null
			]
		},
		countryCode: {
			type: ["string", "null"],
			minLength: 2,
			maxLength: 2,
			pattern: "^[A-Z]{2}$",
			description: "ISO 3166-1 alpha-2 country code"
		},
		shipmentDirection: {
			type: "string",
			enum: ["OUTBOUND", "INBOUND"]
		},
		fallback: { type: "boolean" }
	}
}, jm = {
	$schema: "http://json-schema.org/draft-07/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		items: { $ref: "#/components/schemas/_ref_notification_response_notification_template" }
	} }
}, Mm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Notification Template response item",
	type: "object",
	required: [
		"id",
		"notificationGroupId",
		"type",
		"subject",
		"body",
		"active"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		notificationGroupId: { type: "integer" },
		type: { $ref: "#/components/schemas/_ref_notification_notification_template_type" },
		subject: { type: "string" },
		body: { type: "string" },
		active: { type: "boolean" }
	}
}, Nm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The notification template type.",
	type: "string",
	enum: [
		"LABEL_DOWNLOAD",
		"FIRST_SCAN",
		"RETURN"
	]
}, Pm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["webhook_subscriptions"],
		properties: { webhook_subscriptions: {
			type: "array",
			items: { $ref: "#/components/schemas/webhooks_responses_webhook-v1.1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Fm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Webhook Subscription response item",
	type: "object",
	required: [
		"id",
		"account_id",
		"shop_id",
		"hook",
		"url"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" },
		payload: { type: ["string", "null"] }
	}
}, Im = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["webhook_subscriptions"],
		properties: { webhook_subscriptions: {
			type: "array",
			items: { $ref: "#/components/schemas/webhooks_responses_webhook-v1.0" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Lm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Webhook Subscription response item",
	type: "object",
	required: [
		"id",
		"account_id",
		"shop_id",
		"hook",
		"url"
	],
	properties: {
		id: { type: "integer" },
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" }
	}
}, Rm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["ids"],
		additionalProperties: !1,
		properties: { ids: {
			type: "array",
			description: "A list of created webhook subscription IDs.",
			items: {
				type: "object",
				required: ["id"],
				additionalProperties: !1,
				properties: { id: { type: "integer" } }
			}
		} }
	} }
}, zm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.Barcode",
	type: "string",
	minLength: 6,
	maxLength: 32,
	pattern: "^[a-zA-Z0-9\\-\\s]+$"
}, Bm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierIdentifier",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/shipment_parameters_carrier_id" }, { $ref: "#/components/schemas/shipment_parameters_carrier_name" }]
}, Vm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierId",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: ["string", "null"],
	enum: [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"10",
		"11",
		"12",
		"13",
		"14",
		"15",
		"16",
		"17",
		"18",
		"19",
		"20",
		"21"
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["1"]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: ["2"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["3"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["4"]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: ["5"]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: ["6"]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: ["7"]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: ["8"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["9"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["10"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["11"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["12"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["13"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["14"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["15"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["16"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["17"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["18"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["19"]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: ["20"]
		},
		{
			description: "DHL Freight",
			title: "DhlFreight",
			enum: ["21"]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim",
		"DhlFreight"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"Via Tim",
		"DHL Freight"
	]
}, Hm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierName",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: "string",
	enum: [
		"postnl",
		"bpost",
		"cheapcargo",
		"dpd",
		"instabox",
		"dhl",
		"bol.com",
		"ups",
		"dhlforyou",
		"dhlparcelconnect",
		"dhleuroplus",
		"upsstandard",
		"upsexpresssaver",
		"gls",
		"brt",
		"trunkrs",
		"inpost",
		"posteitaliane",
		"spring",
		"viatim",
		"dhlfreight"
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["postnl"]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: ["bpost"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["cheapcargo"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["dpd"]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: ["instabox"]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: ["dhl"]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: ["bol.com"]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: ["ups"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["dhlforyou"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["dhlparcelconnect"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["dhleuroplus"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["upsstandard"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["upsexpresssaver"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["gls"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["brt"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["trunkrs"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["inpost"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["posteitaliane"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["spring"]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: ["viatim"]
		},
		{
			description: "DHL Freight",
			title: "DhlFreight",
			enum: ["dhlfreight"]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim",
		"DhlFreight"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"ViaTim",
		"DHL Freight"
	]
}, Um = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "collect_date",
	type: ["string", "null"],
	format: "date",
	pattern: "\\d{4}-\\d{2}-\\d{2}"
}, Wm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.CountryCode",
	description: "ISO 3166-1 alpha-2 country code",
	type: "string",
	maxLength: 2,
	minLength: 2,
	pattern: "^[A-Za-z]{2}$"
}, Gm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CutoffTime",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }]
}, Km = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Boolean",
	anyOf: [
		{ type: "boolean" },
		{
			type: "integer",
			minimum: 0,
			maximum: 1
		},
		{
			type: "number",
			anyOf: [{
				minimum: 0,
				maximum: 0
			}, {
				minimum: 1,
				maximum: 1
			}]
		},
		{
			type: "string",
			enum: [
				"0",
				"1",
				"false",
				"true"
			]
		}
	]
}, qm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.FilterValidateBool",
	type: [
		"boolean",
		"integer",
		"string",
		"null"
	],
	enum: [
		!1,
		!0,
		0,
		1,
		"0",
		"1",
		"false",
		"true",
		"off",
		"on",
		"no",
		"yes",
		"",
		null
	]
}, Jm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryDate",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_date" }, { type: "null" }]
}, Ym = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryTime",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }]
}, Xm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "delivery_options_identifier",
	type: ["string", "null"]
}, Zm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.WeekdayDigit",
	description: "A semi-colon delimited list of weekday digits between 0 and 6 (0 = Sunday).\n",
	type: ["string", "null"],
	pattern: "^([0-6](;[0-6])*)?$"
}, Qm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryTypes",
	type: "string",
	anyOf: [{ $ref: "#/components/schemas/shipment_parameters_delivery_type" }, { pattern: "^[1-8](;[1-8])*$" }]
}, $m = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryType",
	type: "string",
	enum: [
		"1",
		"2",
		"3",
		"4",
		"6",
		"7",
		"8"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["1"]
		},
		{
			title: "Standard",
			enum: ["2"]
		},
		{
			title: "Evening",
			enum: ["3"]
		},
		{
			title: "Pickup",
			enum: ["4"]
		},
		{
			title: "SameDay",
			enum: ["6"]
		},
		{
			title: "Express",
			enum: ["7"]
		},
		{
			title: "EarlyMorning",
			enum: ["8"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, eh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "paper_size",
	description: "The size of a paper as specified in ISO216.",
	type: "string",
	enum: ["A4", "A6"]
}, th = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Latitude",
	type: [
		"number",
		"string",
		"null"
	],
	anyOf: [{ $ref: "#/components/schemas/common_defs_latitude" }, { type: "null" }]
}, nh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Longitude",
	type: [
		"number",
		"string",
		"null"
	],
	anyOf: [{ $ref: "#/components/schemas/common_defs_longitude" }, { type: "null" }]
}, rh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "order",
	description: "Specify whether the results should be sorted in ascending or descending order.",
	type: "string",
	enum: ["ASC", "DESC"],
	oneOf: [{
		enum: ["ASC"],
		title: "Ascending",
		description: "Results are ordered from lesser to greater values, e.g. from A to Z."
	}, {
		enum: ["DESC"],
		title: "Descending",
		description: "Results are ordered from greater to lesser values, e.g. from Z to A."
	}]
}, ih = {
	$schema: "https://json-schema.org/draft-04/schema#",
	title: "Shipment Package Type",
	anyOf: [
		{ $ref: "#/components/schemas/_ref_shipment_package_type" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		{
			type: "string",
			pattern: "^[1-7](;[1-7]){0,5}$"
		}
	]
}, ah = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "page",
	description: "Request a specific page of the results, used for paginated results.",
	type: "integer",
	minimum: 1,
	maximum: 1e3
}, oh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.parameters.PlatformIdentifier",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/account_defs_platform_name" }, { $ref: "#/components/schemas/account_parameters_platform_id" }]
}, sh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.defs.PlatformName",
	type: "string",
	enum: [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	],
	oneOf: [
		{
			title: "myparcel",
			enum: ["myparcel"]
		},
		{
			title: "flespakket",
			enum: ["flespakket"]
		},
		{
			title: "belgie",
			enum: ["belgie"]
		},
		{
			title: "delivery_dutch",
			enum: ["delivery_dutch"]
		},
		{
			title: "postnl_customer",
			enum: ["postnl_customer"]
		},
		{
			title: "italy",
			enum: ["italy"]
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, ch = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.parameters.PlatformId",
	type: "string",
	enum: [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6"
	],
	oneOf: [
		{
			title: "myparcel",
			enum: ["1"]
		},
		{
			title: "flespakket",
			enum: ["2"]
		},
		{
			title: "belgie",
			enum: ["3"]
		},
		{
			title: "delivery_dutch",
			enum: ["4"]
		},
		{
			title: "postnl_customer",
			enum: ["5"]
		},
		{
			title: "italy",
			enum: ["6"]
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, lh = {
	$schema: "https://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.LabelPosition",
	description: "The position of the label on the paper.",
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_label_printing_position" }, {
		type: "string",
		pattern: "^[0-4](;[1-4]){0,3}$"
	}]
}, uh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.label.PrintingPosition",
	description: "The position of the label on the paper.",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4
	],
	oneOf: [
		{
			enum: [1],
			title: "TopLeftQuadrant",
			description: "Top-Left Quadrant"
		},
		{
			enum: [2],
			title: "TopRightQuadrant",
			description: "Top-Right Quadrant"
		},
		{
			enum: [3],
			title: "BottomLeftQuadrant",
			description: "Bottom-Left Quadrant"
		},
		{
			enum: [4],
			title: "BottomRightQuadrant",
			description: "Bottom-Right Quadrant"
		}
	],
	"x-enum-varnames": [
		"TopLeftQuadrant",
		"TopRightQuadrant",
		"BottomLeftQuadrant",
		"BottomRightQuadrant"
	],
	"x-enum-descriptions": [
		"Top-Left Quadrant",
		"Top-Right Quadrant",
		"Bottom-Left Quadrant",
		"Bottom-Right Quadrant"
	]
}, dh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.PostalCode",
	type: ["string", "null"],
	minLength: 2,
	maxLength: 12,
	pattern: "^[a-zA-Z0-9\\-\\s]{2,12}$",
	format: "postal-code"
}, fh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.BigIds",
	type: ["integer", "string"],
	anyOf: [{ $ref: "#/components/schemas/common_parameters_bigid" }, {
		type: "string",
		pattern: "^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$"
	}]
}, ph = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.BigId",
	type: "integer",
	format: "int64",
	minimum: 1,
	maximum: 0x8000000000000000
}, mh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	anyOf: [
		{ $ref: "#/components/schemas/_ref_shipment_type" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_type" }
		},
		{
			type: "string",
			pattern: "^[1-8](;[1-8]){0,7}$"
		}
	]
}, hh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ids",
	anyOf: [
		{ $ref: "#/components/schemas/common_parameters_id" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/common_parameters_id" }
		},
		{
			type: "string",
			pattern: "^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$"
		}
	]
}, gh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "id",
	type: "integer",
	format: "int32",
	minimum: 1,
	maximum: 2147483647
}, _h = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "size",
	description: "Specify the number of resources returned per page, used for paginated results.",
	type: "integer",
	minimum: 0,
	maximum: 1e4
}, vh = {
	$schema: "http://package-json.org/draft-04/schema#",
	type: "string",
	enum: [
		"amount",
		"created",
		"created_by",
		"currency",
		"drop_off_point",
		"hidden",
		"id",
		"mark_delivered",
		"modified",
		"modified_by",
		"order_shipment_identifier",
		"parent_id",
		"recipient",
		"reference_identifier",
		"sender",
		"shipment_type",
		"shop_id",
		"status",
		"transaction_status"
	]
}, yh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	oneOf: [
		{ $ref: "#/components/schemas/shipment_defs_shipment_status" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_shipment_status" }
		},
		{
			type: "string",
			pattern: "^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$"
		}
	]
}, bh = {
	$schema: "http://package-json.org/draft-04/schema#",
	title: "extra_info",
	type: "string",
	pattern: "^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\\1(?:;|$)))+;*$"
}, xh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: {
			user_agent: {
				type: "string",
				maxLength: 255
			},
			shipments: {
				type: "array",
				minItems: 1,
				maxItems: 100,
				items: {
					type: "object",
					required: [
						"options",
						"carrier",
						"recipient"
					],
					additionalProperties: !1,
					properties: {
						account_id: { type: "integer" },
						shop_id: { type: "integer" },
						contract_id: { type: "integer" },
						reference_identifier: {
							type: ["integer", "string"],
							maxLength: 255,
							pattern: "^[^=\\?]*$"
						},
						recipient: {
							type: "object",
							required: [
								"cc",
								"postal_code",
								"city",
								"street",
								"person"
							],
							additionalProperties: !1,
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								region: {
									type: "string",
									maxLength: 35
								},
								state: {
									type: "string",
									maxLength: 2
								},
								postal_code: {
									type: "string",
									maxLength: 10
								},
								city: {
									type: "string",
									maxLength: 35,
									minLength: 1
								},
								street: {
									type: "string",
									maxLength: 40,
									minLength: 1,
									pattern: "\\D+"
								},
								street_additional_info: {
									type: "string",
									maxLength: 50
								},
								number: {
									type: "string",
									maxLength: 8
								},
								number_suffix: {
									type: "string",
									maxLength: 6
								},
								box_number: {
									type: "string",
									maxLength: 8
								},
								area: {
									type: "string",
									maxLength: 35
								},
								person: {
									type: "string",
									maxLength: 50,
									minLength: 1
								},
								company: {
									type: "string",
									maxLength: 50
								},
								email: { anyOf: [{
									type: "string",
									format: "email"
								}, {
									type: "string",
									maxLength: 0
								}] },
								secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
								phone: {
									type: "string",
									maxLength: 25
								},
								eori_number: { type: ["string", "null"] },
								vat_number: { type: ["string", "null"] }
							}
						},
						sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
						recipients: {
							type: "array",
							minItems: 1,
							items: { type: "number" }
						},
						physical_properties: {
							type: "object",
							required: ["weight"],
							additionalProperties: !1,
							properties: {
								weight: {
									type: "integer",
									minimum: 0,
									maximum: 999999999
								},
								height: { type: "integer" },
								width: { type: "integer" },
								length: { type: "integer" },
								volume: { type: "integer" }
							}
						},
						options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
						customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
						carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
						pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
						drop_off_point: {
							type: ["object", "null"],
							required: [
								"location_code",
								"postal_code",
								"location_name",
								"city",
								"street",
								"number"
							],
							additionalProperties: !1,
							properties: {
								postal_code: { type: "string" },
								location_name: { type: "string" },
								city: { type: "string" },
								street: { type: "string" },
								number: { type: "string" },
								number_suffix: { type: "string" },
								box_number: { type: "string" },
								region: { type: "string" },
								state: { type: "string" },
								cc: { type: "string" },
								location_code: { type: "string" },
								retail_network_id: { type: "string" }
							}
						},
						note: { type: "string" },
						status: {
							type: "integer",
							enum: [
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8
							]
						},
						delivered: {
							type: "integer",
							enum: [0]
						},
						general_settings: {
							type: "object",
							additionalProperties: !1,
							properties: {
								save_recipient_address: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification_email: {
									type: "array",
									items: { type: "string" }
								},
								disable_auto_detect_pickup: {
									type: "integer",
									enum: [0, 1]
								},
								printer_identifier: { type: "string" }
							}
						},
						secondary_shipments: {
							type: "array",
							minItems: 1,
							items: {
								type: "object",
								additionalProperties: !1,
								properties: {
									account_id: { type: "integer" },
									shop_id: { type: "integer" },
									reference_identifier: {
										type: ["integer", "string"],
										maxLength: 255,
										pattern: "^[^=\\?]*$"
									},
									recipient: {
										type: "object",
										additionalProperties: !1,
										properties: {
											cc: {
												type: "string",
												minLength: 2,
												maxLength: 2
											},
											region: {
												type: "string",
												maxLength: 35
											},
											state: {
												type: "string",
												maxLength: 2
											},
											postal_code: {
												type: "string",
												maxLength: 10
											},
											city: {
												type: "string",
												maxLength: 35,
												minLength: 1
											},
											street: {
												type: "string",
												maxLength: 40,
												minLength: 1
											},
											street_additional_info: {
												type: "string",
												maxLength: 50
											},
											number: {
												type: "string",
												maxLength: 8
											},
											number_suffix: {
												type: "string",
												maxLength: 6
											},
											box_number: {
												type: "string",
												maxLength: 8
											},
											area: {
												type: "string",
												maxLength: 35
											},
											person: {
												type: "string",
												maxLength: 50,
												minLength: 1
											},
											company: {
												type: "string",
												maxLength: 50
											},
											email: { anyOf: [{
												type: "string",
												format: "email"
											}, {
												type: "string",
												maxLength: 0
											}] },
											secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
											phone: {
												type: "string",
												maxLength: 25
											},
											eori_number: { type: ["string", "null"] },
											vat_number: { type: ["string", "null"] }
										}
									},
									recipients: {
										type: "array",
										minItems: 1,
										items: { type: "number" }
									},
									physical_properties: {
										type: "object",
										required: ["weight"],
										additionalProperties: !1,
										properties: {
											weight: {
												type: "integer",
												minimum: 0,
												maximum: 999999999
											},
											height: { type: "integer" },
											width: { type: "integer" },
											length: { type: "integer" },
											volume: { type: "integer" }
										}
									},
									options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
									customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
									carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
									pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
									drop_off_point: {
										type: ["object", "null"],
										required: [
											"location_code",
											"postal_code",
											"location_name",
											"city",
											"street",
											"number"
										],
										additionalProperties: !1,
										properties: {
											postal_code: { type: "string" },
											location_name: { type: "string" },
											city: { type: "string" },
											street: { type: "string" },
											number: { type: "string" },
											number_suffix: { type: "string" },
											box_number: { type: "string" },
											region: { type: "string" },
											state: { type: "string" },
											cc: { type: "string" },
											location_code: { type: "string" },
											retail_network_id: { type: "string" }
										}
									},
									note: { type: "string" },
									status: {
										type: "integer",
										enum: [
											1,
											2,
											3,
											4,
											5,
											6,
											7,
											8
										]
									},
									delivered: {
										type: "integer",
										enum: [0]
									},
									general_settings: {
										type: "object",
										additionalProperties: !1,
										properties: { save_recipient_address: {
											type: "integer",
											enum: [0, 1]
										} }
									},
									hidden: {
										type: "integer",
										enum: [0, 1]
									},
									shipped_items: {
										type: "array",
										minItems: 0,
										items: {
											type: "object",
											required: ["order_line_identifier", "quantity"],
											properties: {
												order_line_identifier: { type: "string" },
												quantity: {
													type: "integer",
													minimum: 1
												}
											}
										}
									}
								}
							}
						},
						collection_contact: {
							required: [
								"cc",
								"city",
								"company",
								"email",
								"last_name",
								"number",
								"phone",
								"postal_code",
								"street"
							],
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								city: {
									type: "string",
									maxLength: 255,
									minLength: 1
								},
								company: { type: ["string"] },
								email: {
									type: "string",
									format: "email"
								},
								first_name: { type: "string" },
								gender: {
									type: "string",
									enum: ["mr", "mrs"]
								},
								last_name: { type: "string" },
								number: {
									type: ["string", "integer"],
									minLength: 1
								},
								number_suffix: { type: ["string", "null"] },
								phone: {
									type: "string",
									minLength: 8
								},
								postal_code: {
									type: "string",
									minLength: 1
								},
								street: {
									type: "string",
									minLength: 1
								},
								street_additional_info: { type: ["string", "null"] }
							},
							type: "object"
						},
						hidden: {
							type: "integer",
							enum: [0, 1]
						},
						shipped_items: {
							type: "array",
							minItems: 0,
							items: {
								type: "object",
								required: ["order_line_identifier", "quantity"],
								properties: {
									order_line_identifier: { type: "string" },
									quantity: {
										type: "integer",
										minimum: 1
									}
								}
							}
						}
					}
				}
			}
		}
	} }
}, Sh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "array",
	maxItems: 4,
	items: { anyOf: [{
		type: "string",
		format: "email"
	}, {
		type: "string",
		maxLength: 0
	}] }
}, Ch = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"cc",
		"postal_code",
		"city",
		"street",
		"person"
	],
	properties: {
		cc: {
			type: "string",
			minLength: 2,
			maxLength: 2
		},
		postal_code: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		street_additional_info: { type: ["null", "string"] },
		number: { type: "string" },
		number_suffix: { type: "string" },
		box_number: {
			type: "string",
			maxLength: 8
		},
		region: {
			type: "string",
			maxLength: 35
		},
		person: { type: "string" },
		company: { type: "string" },
		phone: { type: "string" },
		email: { anyOf: [
			{
				type: "string",
				format: "email"
			},
			{
				type: "string",
				maxLength: 0
			},
			{ type: "null" }
		] }
	},
	additionalProperties: !1
}, wh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["object", "null"],
	properties: {
		postal_code: { type: "string" },
		location_name: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] },
		box_number: {
			type: "string",
			maxLength: 8
		},
		region: {
			type: "string",
			maxLength: 35
		},
		state: {
			type: "string",
			maxLength: 2
		},
		cc: {
			type: "string",
			maxLength: 2,
			minLength: 2,
			pattern: "^[A-Z]{2}"
		},
		location_code: { type: "string" },
		location_type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_bpost_bpost_pugo_type" }, { $ref: "#/components/schemas/_ref_shipment_location_type" }] },
		retail_network_id: { type: "string" }
	},
	additionalProperties: !1
}, Th = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		required: ["shipments"],
		properties: {
			user_agent: {
				type: "string",
				maxLength: 255
			},
			shipments: {
				type: "array",
				minItems: 1,
				maxItems: 100,
				items: {
					type: "object",
					required: [
						"carrier",
						"recipient",
						"options"
					],
					additionalProperties: !1,
					properties: {
						account_id: { type: "integer" },
						shop_id: { type: "integer" },
						reference_identifier: {
							type: ["integer", "string"],
							maxLength: 255,
							pattern: "^[^=\\?]*$"
						},
						recipient: {
							type: "object",
							required: [
								"cc",
								"city",
								"street",
								"person"
							],
							additionalProperties: !1,
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								region: {
									type: "string",
									maxLength: 35
								},
								state: {
									type: "string",
									maxLength: 2
								},
								postal_code: {
									type: "string",
									maxLength: 10
								},
								city: {
									type: "string",
									maxLength: 35,
									minLength: 1
								},
								street: {
									type: "string",
									maxLength: 40,
									minLength: 1,
									pattern: "\\D+"
								},
								street_additional_info: {
									type: "string",
									maxLength: 50
								},
								number: {
									type: "string",
									maxLength: 8
								},
								number_suffix: {
									type: "string",
									maxLength: 6
								},
								box_number: {
									type: "string",
									maxLength: 8
								},
								area: {
									type: "string",
									maxLength: 35
								},
								person: {
									type: "string",
									maxLength: 50,
									minLength: 1
								},
								company: {
									type: "string",
									maxLength: 50
								},
								email: { anyOf: [{
									type: "string",
									format: "email"
								}, {
									type: "string",
									maxLength: 0
								}] },
								secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
								phone: {
									type: "string",
									maxLength: 25
								}
							}
						},
						sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
						recipients: {
							type: "array",
							minItems: 1,
							items: { type: "number" }
						},
						physical_properties: {
							type: "object",
							required: ["weight"],
							additionalProperties: !1,
							properties: {
								weight: {
									type: "integer",
									minimum: 0,
									maximum: 999999999
								},
								height: { type: "integer" },
								width: { type: "integer" },
								length: { type: "integer" },
								volume: { type: "integer" }
							}
						},
						options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
						customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
						carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
						pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
						"multi-colli": {
							type: ["object", "null"],
							required: ["amount"],
							additionalProperties: !1,
							properties: { amount: { type: "integer" } }
						},
						note: { type: "string" },
						status: {
							type: "integer",
							enum: [
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8
							]
						},
						delivered: {
							type: "integer",
							enum: [0]
						},
						general_settings: {
							type: "object",
							additionalProperties: !1,
							properties: {
								save_recipient_address: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification_email: {
									type: "array",
									items: { type: "string" }
								},
								disable_auto_detect_pickup: {
									type: "integer",
									enum: [0, 1]
								},
								printer_identifier: { type: "string" }
							}
						},
						hidden: {
							type: "integer",
							enum: [0, 1]
						}
					}
				}
			}
		}
	} }
}, Eh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Return Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { return_shipments: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: [
					"parent",
					"carrier",
					"email",
					"name"
				],
				allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options_returns" }],
				properties: {
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					contract_id: { type: "integer" },
					parent: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier_returns" },
					email: { type: "string" },
					name: { type: "string" },
					sender: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							postal_code: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							street_additional_info: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: {
								type: "string",
								maxLength: 8
							},
							region: {
								type: "string",
								maxLength: 35
							},
							person: { type: "string" },
							company: { type: "string" },
							email: { anyOf: [
								{
									type: "string",
									format: "email"
								},
								{
									type: "string",
									maxLength: 0
								},
								{ type: "null" }
							] },
							phone: { type: "string" }
						}
					},
					physical_properties: {
						type: "object",
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					general_settings: {
						type: "object",
						properties: { save_recipient_address: {
							type: "integer",
							enum: [0, 1]
						} }
					}
				}
			}
		} }
	} }
}, Dh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { options: {
		type: "object",
		allOf: [
			{ $ref: "#/components/schemas/_ref_shipment_options_package_type_returns" },
			{ $ref: "#/components/schemas/_ref_shipment_options_insurance_max" },
			{ $ref: "#/components/schemas/_ref_shipment_options_options_returns" },
			{ $ref: "#/components/schemas/_ref_shipment_options_label_description" }
		],
		properties: {
			contribution: {
				allOf: [{ $ref: "#/components/schemas/_ref_types_money" }],
				properties: { amount: { maximum: 1e5 } }
			},
			printerless_return: { $ref: "#/components/schemas/_ref_types_int_boolean" }
		}
	} }
}, Oh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { package_type: {
		type: "integer",
		enum: [
			1,
			2,
			6
		],
		anyOf: [
			{ $ref: "#/components/schemas/_ref_shipment_package_type_1_package" },
			{ $ref: "#/components/schemas/_ref_shipment_package_type_2_mailbox" },
			{ $ref: "#/components/schemas/_ref_shipment_package_type_6_small_package" }
		]
	} }
}, kh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [1],
	title: "Package",
	description: "Regular package."
}, Ah = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [2],
	title: "Mailbox",
	description: "Shipment that fits through a mailbox slot."
}, jh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [6],
	title: "Small Package"
}, Mh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		extra_assurance: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		hide_sender: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		large_format: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		only_recipient: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		receipt_code: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		return: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		signature: { $ref: "#/components/schemas/_ref_types_int_boolean" }
	}
}, Nh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [
		1,
		2,
		4,
		9,
		10,
		11,
		14,
		15,
		17,
		18
	]
}, Ph = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Return Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { return_shipments: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: ["carrier"],
				allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options_returns" }],
				properties: {
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					carrier: { $ref: "#/components/schemas/_ref_types_carrier_returns" },
					email: { type: "string" },
					name: { type: "string" },
					cc: { type: "string" },
					sender: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							postal_code: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							street_additional_info: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: {
								type: "string",
								maxLength: 8
							},
							region: {
								type: "string",
								maxLength: 35
							},
							person: { type: "string" },
							company: { type: "string" },
							email: { anyOf: [
								{
									type: "string",
									format: "email"
								},
								{
									type: "string",
									maxLength: 0
								},
								{ type: "null" }
							] },
							phone: { type: "string" }
						}
					},
					physical_properties: {
						type: "object",
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					general_settings: {
						type: "object",
						properties: { save_recipient_address: {
							type: "integer",
							enum: [0, 1]
						} }
					}
				}
			}
		} }
	} }
}, Fh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: [
					"id",
					"carrier",
					"recipient",
					"options"
				],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					contract_id: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
					status: { type: "integer" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					},
					recipient: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							region: {
								type: "string",
								maxLength: 32
							},
							state: {
								type: "string",
								maxLength: 2
							},
							postal_code: {
								type: "string",
								maxLength: 10
							},
							city: {
								type: "string",
								maxLength: 35
							},
							street: {
								type: "string",
								maxLength: 40
							},
							street_additional_info: {
								type: "string",
								maxLength: 50
							},
							number: {
								type: ["string", "null"],
								maxLength: 8
							},
							number_suffix: {
								type: ["string", "null"],
								maxLength: 6
							},
							box_number: {
								type: "string",
								maxLength: 8
							},
							person: {
								type: "string",
								maxLength: 50
							},
							company: {
								type: "string",
								maxLength: 50
							},
							email: { anyOf: [{
								type: "string",
								format: "email"
							}, {
								type: "string",
								maxLength: 0
							}] },
							secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
							phone: {
								type: "string",
								maxLength: 25
							},
							eori_number: { type: ["string", "null"] },
							vat_number: { type: ["string", "null"] }
						}
					},
					sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
					options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					physical_properties: {
						type: "object",
						required: ["weight"],
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					pickup: {
						required: [
							"postal_code",
							"location_name",
							"city",
							"street"
						],
						$ref: "#/components/schemas/_ref_shipment_pickup"
					},
					drop_off_point: {
						type: ["object", "null"],
						required: [
							"location_code",
							"postal_code",
							"location_name",
							"city",
							"street",
							"number"
						],
						additionalProperties: !1,
						properties: {
							postal_code: { type: "string" },
							location_name: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: { type: "string" },
							region: { type: "string" },
							state: { type: "string" },
							cc: { type: "string" },
							location_code: { type: "string" },
							retail_network_id: { type: "string" }
						}
					},
					note: { type: "string" },
					general_settings: {
						type: "object",
						additionalProperties: !1,
						properties: {
							save_recipient_address: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification_email: {
								type: "array",
								items: { type: "string" }
							},
							disable_auto_detect_pickup: {
								type: "integer",
								enum: [0, 1]
							},
							printer_identifier: { type: "string" }
						}
					},
					multi_collo_main_shipment_id: { type: ["integer", "null"] },
					secondary_shipments: {
						type: "array",
						minItems: 1,
						items: {
							type: "object",
							additionalProperties: !1,
							properties: {
								id: { type: "integer" },
								account_id: { type: "integer" },
								shop_id: { type: "integer" },
								reference_identifier: {
									type: ["integer", "string"],
									maxLength: 255,
									pattern: "^[^=\\?]*$"
								},
								recipient: {
									type: "object",
									additionalProperties: !1,
									properties: {
										cc: {
											type: "string",
											minLength: 2,
											maxLength: 2
										},
										region: {
											type: "string",
											maxLength: 35
										},
										state: {
											type: "string",
											maxLength: 2
										},
										postal_code: {
											type: "string",
											maxLength: 10
										},
										city: {
											type: "string",
											maxLength: 35,
											minLength: 1
										},
										street: {
											type: "string",
											maxLength: 40,
											minLength: 1
										},
										street_additional_info: {
											type: "string",
											maxLength: 50
										},
										number: {
											type: ["string", "null"],
											maxLength: 8
										},
										number_suffix: {
											type: ["string", "null"],
											maxLength: 6
										},
										box_number: {
											type: "string",
											maxLength: 8
										},
										area: {
											type: "string",
											maxLength: 35
										},
										person: {
											type: "string",
											maxLength: 50,
											minLength: 1
										},
										company: {
											type: "string",
											maxLength: 50
										},
										email: { anyOf: [{
											type: "string",
											format: "email"
										}, {
											type: "string",
											maxLength: 0
										}] },
										secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
										phone: {
											type: "string",
											maxLength: 25
										},
										eori_number: { type: ["string", "null"] },
										vat_number: { type: ["string", "null"] }
									}
								},
								recipients: {
									type: "array",
									minItems: 1,
									items: { type: "number" }
								},
								physical_properties: {
									type: "object",
									required: ["weight"],
									additionalProperties: !1,
									properties: {
										weight: {
											type: "integer",
											minimum: 0,
											maximum: 999999999
										},
										height: { type: "integer" },
										width: { type: "integer" },
										length: { type: "integer" },
										volume: { type: "integer" }
									}
								},
								options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
								customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
								carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
								pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
								drop_off_point: {
									type: ["object", "null"],
									required: [
										"location_code",
										"postal_code",
										"location_name",
										"city",
										"street",
										"number"
									],
									additionalProperties: !1,
									properties: {
										postal_code: { type: "string" },
										location_name: { type: "string" },
										city: { type: "string" },
										street: { type: "string" },
										number: { type: "string" },
										number_suffix: { type: "string" },
										box_number: { type: "string" },
										region: { type: "string" },
										state: { type: "string" },
										cc: { type: "string" },
										location_code: { type: "string" },
										retail_network_id: { type: "string" }
									}
								},
								note: { type: "string" },
								status: {
									type: "integer",
									enum: [
										1,
										2,
										3,
										4,
										5,
										6,
										7,
										8
									]
								},
								delivered: {
									type: "integer",
									enum: [0, 1]
								},
								general_settings: {
									type: "object",
									additionalProperties: !1,
									properties: { save_recipient_address: {
										type: "integer",
										enum: [0, 1]
									} }
								},
								multi_collo_main_shipment_id: { type: ["integer", "null"] },
								hidden: {
									type: "integer",
									enum: [0, 1]
								},
								shipped_items: {
									type: "array",
									minItems: 0,
									items: {
										type: "object",
										required: ["order_line_identifier", "quantity"],
										properties: {
											order_line_identifier: { type: "string" },
											quantity: {
												type: "integer",
												minimum: 1
											}
										}
									}
								}
							}
						}
					},
					collection_contact: {
						required: [
							"cc",
							"city",
							"number",
							"phone",
							"postal_code",
							"street"
						],
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							city: {
								type: "string",
								maxLength: 255,
								minLength: 1
							},
							company: { type: ["string", "null"] },
							email: {
								type: "string",
								format: "email"
							},
							first_name: { type: "string" },
							gender: {
								type: "string",
								enum: ["mr", "mrs"]
							},
							last_name: { type: "string" },
							number: {
								type: ["string", "integer"],
								minLength: 1
							},
							number_suffix: { type: ["string", "null"] },
							phone: {
								type: "string",
								minLength: 8
							},
							postal_code: {
								type: "string",
								minLength: 1
							},
							street: {
								type: "string",
								minLength: 1
							},
							street_additional_info: { type: ["string", "null"] }
						},
						type: "object"
					},
					hidden: {
						type: "integer",
						enum: [0, 1]
					},
					shipped_items: {
						type: "array",
						minItems: 0,
						items: {
							type: "object",
							required: ["order_line_identifier", "quantity"],
							properties: {
								order_line_identifier: { type: "string" },
								quantity: {
									type: "integer",
									minimum: 1
								}
							}
						}
					}
				}
			}
		} }
	} }
}, Ih = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: [
					"id",
					"carrier",
					"recipient",
					"options"
				],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
					status: { type: "integer" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					},
					recipient: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							region: {
								type: "string",
								maxLength: 32
							},
							state: {
								type: "string",
								maxLength: 2
							},
							postal_code: {
								type: "string",
								maxLength: 10
							},
							city: {
								type: "string",
								maxLength: 35
							},
							street: {
								type: "string",
								maxLength: 40
							},
							street_additional_info: {
								type: "string",
								maxLength: 50
							},
							number: {
								type: ["string", "null"],
								maxLength: 8
							},
							number_suffix: {
								type: ["string", "null"],
								maxLength: 6
							},
							box_number: {
								type: "string",
								maxLength: 8
							},
							person: {
								type: "string",
								maxLength: 50
							},
							company: {
								type: "string",
								maxLength: 50
							},
							email: { anyOf: [{
								type: "string",
								format: "email"
							}, {
								type: "string",
								maxLength: 0
							}] },
							secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
							phone: {
								type: "string",
								maxLength: 25
							}
						}
					},
					sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
					options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					physical_properties: {
						type: "object",
						required: ["weight"],
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					pickup: {
						required: [
							"postal_code",
							"location_name",
							"city",
							"street"
						],
						$ref: "#/components/schemas/_ref_shipment_pickup"
					},
					note: { type: "string" },
					general_settings: {
						type: "object",
						additionalProperties: !1,
						properties: {
							save_recipient_address: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification_email: {
								type: "array",
								items: { type: "string" }
							},
							disable_auto_detect_pickup: {
								type: "integer",
								enum: [0, 1]
							},
							printer_identifier: { type: "string" }
						}
					},
					hidden: {
						type: "integer",
						enum: [0, 1]
					}
				}
			}
		} }
	} }
}, Lh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		required: ["shipments"],
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: ["id"],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					hidden: {
						type: "integer",
						enum: [0, 1]
					},
					status: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					}
				}
			}
		} }
	} }
}, Rh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine capabilities V2",
	type: "object",
	required: ["recipient"],
	additionalProperties: !1,
	properties: {
		shopId: {
			type: "integer",
			description: "The ID of the shop for which the capabilities are requested."
		},
		contractId: {
			type: "integer",
			description: "The ID of the contract for which the capabilities are requested."
		},
		recipient: {
			type: "object",
			description: "Recipient data.",
			required: ["countryCode"],
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the recipient.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the recipient.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		sender: {
			type: "object",
			description: "Sender data.",
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the sender.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the sender.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		physicalProperties: {
			type: "object",
			description: "Physical properties of the package.",
			additionalProperties: !1,
			properties: {
				height: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The height value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The height of the package"
				},
				width: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The width value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The width of the package"
				},
				length: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The length value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The length of the package"
				},
				weight: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The weight value"
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of measurement in SI units (e.g., g, kg)"
						}
					},
					description: "The weight of the package"
				}
			}
		},
		options: {
			type: "object",
			additionalProperties: !1,
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Additional insurance option"
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Deliver at postal point option"
				},
				freshFood: {
					type: "object",
					additionalProperties: !1,
					description: "Fresh food delivery option"
				},
				frozen: {
					type: "object",
					additionalProperties: !1,
					description: "Frozen delivery option"
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Hide sender option"
				},
				insurance: {
					oneOf: [{
						type: "object",
						additionalProperties: !1,
						maxProperties: 0
					}, { $ref: "#/components/schemas/_ref_types_money" }],
					description: "Insurance option. Empty object selects the carrier-default coverage. A Money object with amount > 0 requests a specific coverage in minor units; amount 0 (or empty currency) is treated as no insurance requested."
				},
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "Ship without track and trace option"
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Oversized package option"
				},
				printReturnLabelAtDropOff: {
					type: "object",
					additionalProperties: !1,
					description: "Print return label at drop off package option"
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Priority delivery package option"
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Recipient only delivery option"
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Return on first failed delivery option"
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires age verification option"
				},
				requiresCashOnDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Cash on delivery option"
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires receipt code option"
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Requires signature option"
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Same day delivery option"
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Saturday delivery option"
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Scheduled collection option"
				}
			},
			description: "Shipment options object. Empty objects indicate the option is requested/enabled."
		},
		deliveryType: {
			type: "string",
			enum: [
				"EVENING_DELIVERY",
				"EXPRESS_DELIVERY",
				"EARLY_MORNING_DELIVERY",
				"MORNING_DELIVERY",
				"PICKUP_DELIVERY",
				"SAME_DAY_DELIVERY",
				"STANDARD_DELIVERY"
			]
		},
		direction: {
			type: "string",
			enum: ["INBOUND", "OUTBOUND"],
			description: "The shipment direction for which the capabilities are requested."
		},
		pickup: {
			type: "object",
			description: "Pickup location criteria for filtering capabilities.",
			additionalProperties: !1,
			properties: { location: {
				type: "object",
				description: "Pickup location details.",
				additionalProperties: !1,
				properties: { type: { $ref: "#/components/schemas/_ref_shipment_location_type-v2" } }
			} }
		}
	}
}, zh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Pickup / drop-off location type used for capability and rates filtering.",
	type: "string",
	enum: [
		"RETAIL",
		"LOCKER",
		"POST_OFFICE"
	],
	oneOf: [
		{
			enum: ["RETAIL"],
			title: "Retail",
			description: "Shops/postal points."
		},
		{
			enum: ["LOCKER"],
			title: "Locker",
			description: "Automated parcel locker."
		},
		{
			enum: ["POST_OFFICE"],
			title: "PostOffice",
			description: "Post office location."
		}
	],
	"x-enum-varnames": [
		"Retail",
		"Locker",
		"PostOffice"
	]
}, Bh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine capabilities",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["capabilities"],
		additionalProperties: !1,
		properties: { capabilities: {
			type: "array",
			items: {
				type: "object",
				required: ["recipient"],
				additionalProperties: !1,
				properties: {
					shop_id: {
						type: "integer",
						description: "The ID of the shop for which the capabilities are requested."
					},
					contract_id: {
						type: "integer",
						description: "The ID of the contract for which the capabilities are requested."
					},
					recipient: {
						type: "object",
						description: "Recipient data.",
						additionalProperties: !1,
						required: ["cc"],
						properties: {
							cc: {
								description: "Alpha-2 Country code of the recipient.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the recipient.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					sender: {
						type: "object",
						description: "Sender data.",
						additionalProperties: !1,
						properties: {
							cc: {
								description: "Alpha-2 Country code of the sender.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the sender.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
					package_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7
						]
					},
					physical_properties: {
						type: "object",
						description: "Physical properties of the package.",
						additionalProperties: !1,
						properties: {
							height: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The height value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The height of the package"
							},
							width: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The width value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The width of the package"
							},
							length: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The length value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The length of the package"
							},
							weight: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										description: "The weight value"
									},
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of measurement in SI units (e.g., g, kg)"
									}
								},
								description: "The weight of the package"
							}
						}
					},
					options: {
						type: "object",
						additionalProperties: !1,
						description: "Shipment options object. Empty objects indicate the option is requested/enabled.",
						properties: {
							age_check: {
								type: "object",
								additionalProperties: !1,
								description: "Requires age verification option"
							},
							cash_on_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cash on delivery option"
							},
							collect: {
								type: "object",
								additionalProperties: !1,
								description: "Scheduled collection option"
							},
							drop_off_at_postal_point: {
								type: "object",
								additionalProperties: !1,
								description: "Deliver at postal point option"
							},
							extra_assurance: {
								type: "object",
								additionalProperties: !1,
								description: "Additional insurance option"
							},
							fresh_food: {
								type: "object",
								additionalProperties: !1,
								description: "Fresh food delivery option"
							},
							frozen: {
								type: "object",
								additionalProperties: !1,
								description: "Frozen delivery option"
							},
							hide_sender: {
								type: "object",
								additionalProperties: !1,
								description: "Hide sender option"
							},
							large_format: {
								type: "object",
								additionalProperties: !1,
								description: "Oversized package option"
							},
							no_tracking: {
								type: "object",
								additionalProperties: !1,
								description: "Ship without track and trace option"
							},
							only_recipient: {
								type: "object",
								additionalProperties: !1,
								description: "Recipient only delivery option"
							},
							priority_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Priority delivery option"
							},
							printerless_return: {
								type: "object",
								additionalProperties: !1,
								description: "Printerless return delivery option"
							},
							receipt_code: {
								type: "object",
								additionalProperties: !1,
								description: "Requires receipt code option"
							},
							return: {
								type: "object",
								additionalProperties: !1,
								description: "Return on first failed delivery option"
							},
							same_day_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Same day delivery option"
							},
							saturday_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Saturday delivery option"
							},
							signature: {
								type: "object",
								additionalProperties: !1,
								description: "Requires signature option"
							},
							tracked: {
								type: "object",
								additionalProperties: !1,
								description: "DEPRECATED: replaced by no_tracking (its inverse)."
							},
							insurance: {
								oneOf: [{
									type: "object",
									additionalProperties: !1,
									maxProperties: 0
								}, { $ref: "#/components/schemas/_ref_types_money" }],
								description: "Insurance option. Empty object selects the carrier-default coverage. A Money object with amount > 0 requests a specific coverage in minor units; amount 0 (or empty currency) is treated as no insurance requested."
							}
						}
					},
					delivery_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					shipment_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					direction: {
						type: "string",
						enum: ["INBOUND", "OUTBOUND"],
						description: "The shipment direction for which the capabilities are requested."
					},
					pickup: {
						type: "object",
						description: "Pickup location criteria for filtering capabilities.",
						additionalProperties: !1,
						properties: { location_type: { $ref: "#/components/schemas/_ref_shipment_location_type" } }
					}
				}
			}
		} }
	} }
}, Vh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine the superset of contract definitions and carriers available for a given account, v2 format",
	type: "object",
	additionalProperties: !1,
	properties: { carrier: {
		type: "string",
		enum: [
			"BRT",
			"DHL_EUROPLUS",
			"DHL_PARCEL_CONNECT",
			"DPD",
			"DHL_FOR_YOU",
			"INPOST",
			"POSTNL"
		]
	} }
}, Hh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine the superset of contract definitions and carriers available for a given account",
	type: "object",
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { carrier_id: {
			type: "integer",
			format: "int32",
			enum: [
				1,
				4,
				9,
				10,
				11,
				15,
				17
			]
		} }
	} }
}, Uh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine rates V2",
	type: "object",
	required: [
		"carrier",
		"packageType",
		"recipient"
	],
	additionalProperties: !1,
	properties: {
		shopId: {
			type: "integer",
			description: "The ID of the shop for which the rates are requested."
		},
		contractId: {
			type: "integer",
			description: "The ID of the contract for which the rates are requested."
		},
		recipient: {
			type: "object",
			description: "Recipient data.",
			required: ["countryCode"],
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the recipient.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the recipient.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		sender: {
			type: "object",
			description: "Sender data.",
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the sender.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the sender.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		pickup: { $ref: "#/components/schemas/_ref_shipment_pickup-v2" },
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		physicalProperties: {
			type: "object",
			description: "Physical properties of the package.",
			additionalProperties: !1,
			properties: {
				height: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The height value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The height of the package"
				},
				width: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The width value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The width of the package"
				},
				length: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The length value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The length of the package"
				},
				weight: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The weight value"
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of measurement in SI units (e.g., g, kg)"
						}
					},
					description: "The weight of the package"
				}
			}
		},
		options: {
			type: "object",
			additionalProperties: !1,
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Additional insurance option"
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Deliver at postal point option"
				},
				freshFood: {
					type: "object",
					additionalProperties: !1,
					description: "Fresh food option"
				},
				frozen: {
					type: "object",
					additionalProperties: !1,
					description: "Frozen option"
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Hide sender option"
				},
				insurance: {
					oneOf: [{
						type: "object",
						required: ["insuredAmount"],
						additionalProperties: !1,
						properties: { insuredAmount: { $ref: "#/components/schemas/_ref_types_money" } },
						description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release."
					}, { $ref: "#/components/schemas/_ref_types_money" }],
					description: "Insurance option. Provide the insured amount as flat {amount, currency} (recommended) or via the deprecated nested {insuredAmount: Money} form."
				},
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "Ship without track and trace option"
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Oversized package option"
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Priority delivery package option"
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Recipient only delivery option"
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Return on first failed delivery option"
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires age verification option"
				},
				requiresCashOnDelivery: {
					type: "object",
					required: ["dueAmount"],
					properties: { dueAmount: { $ref: "#/components/schemas/_ref_types_money" } },
					additionalProperties: !1,
					description: "Cash on delivery option"
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires receipt code option"
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Requires signature option"
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Same day delivery option"
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Saturday delivery option"
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Scheduled collection option"
				}
			},
			description: "Shipment options object. Empty objects indicate the option is requested/enabled."
		},
		deliveryType: {
			type: "string",
			enum: [
				"EARLY_MORNING_DELIVERY",
				"EVENING_DELIVERY",
				"EXPRESS_DELIVERY",
				"MORNING_DELIVERY",
				"PICKUP_DELIVERY",
				"SAME_DAY_DELIVERY",
				"STANDARD_DELIVERY"
			]
		},
		direction: {
			type: "string",
			enum: ["INBOUND", "OUTBOUND"],
			description: "The shipment direction for which the rates are requested."
		},
		collo: {
			type: "integer",
			minimum: 1,
			description: "The number of collo for which the rates are requested."
		}
	}
}, Wh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	description: "Pickup location data.",
	required: ["address", "location"],
	properties: {
		address: { $ref: "#/components/schemas/_ref_shipment_address-v2" },
		location: { $ref: "#/components/schemas/_ref_shipment_location-v2" },
		retailNetworkId: {
			type: "string",
			enum: ["PNPNL-01", "PNPBE-01"],
			description: "PostNL Retail network ID."
		}
	},
	additionalProperties: !1
}, Gh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: {
			type: "string",
			minLength: 2,
			maxLength: 2,
			pattern: "[A-Z]{2}",
			description: "The country code (ISO 3166-1 alpha-2) of the address."
		},
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address. Only applicable for `countryCode`=`BE`."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: ["countryCode"]
}, Kh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the pickup location."
		},
		code: {
			type: "string",
			minLength: 1,
			maxLength: 64,
			description: "The location code of the pickup location."
		},
		type: { $ref: "#/components/schemas/_ref_shipment_location_type-v2" }
	},
	required: ["name"],
	additionalProperties: !1
}, qh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine rates",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["rates"],
		additionalProperties: !1,
		properties: { rates: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: [
					"carrier_id",
					"package_type",
					"recipient"
				],
				additionalProperties: !1,
				properties: {
					shop_id: {
						type: "integer",
						description: "The ID of the shop for which the rates are requested."
					},
					contract_id: {
						type: "integer",
						description: "The ID of the contract for which the rates are requested."
					},
					recipient: {
						type: "object",
						description: "Recipient data.",
						additionalProperties: !1,
						required: ["cc"],
						properties: {
							cc: {
								description: "Alpha-2 Country code of the recipient.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the recipient.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					sender: {
						type: "object",
						description: "Sender data.",
						additionalProperties: !1,
						properties: {
							cc: {
								description: "Alpha-2 Country code of the sender.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the sender.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
					carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
					package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" },
					physical_properties: {
						type: "object",
						description: "Physical properties of the package.",
						additionalProperties: !1,
						properties: {
							height: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The height value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The height of the package"
							},
							width: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The width value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The width of the package"
							},
							length: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The length value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The length of the package"
							},
							weight: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The weight value"
									},
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of measurement in SI units (e.g., g, kg)"
									}
								},
								description: "The weight of the package"
							}
						}
					},
					options: {
						type: "object",
						additionalProperties: !1,
						description: "Shipment options object. Empty objects indicate the option is requested/enabled.",
						properties: {
							age_check: {
								type: "object",
								additionalProperties: !1,
								description: "Requires age verification option"
							},
							cash_on_delivery: {
								type: "object",
								required: ["due_amount"],
								properties: { due_amount: { $ref: "#/components/schemas/_ref_types_money" } },
								additionalProperties: !1,
								description: "Cash on delivery option"
							},
							collect: {
								type: "object",
								additionalProperties: !1,
								description: "Scheduled collection option"
							},
							cooled_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cooled delivery option"
							},
							drop_off_at_postal_point: {
								type: "object",
								additionalProperties: !1,
								description: "Deliver at postal point option"
							},
							extra_assurance: {
								type: "object",
								additionalProperties: !1,
								description: "Additional insurance option"
							},
							hide_sender: {
								type: "object",
								additionalProperties: !1,
								description: "Hide sender option"
							},
							large_format: {
								type: "object",
								additionalProperties: !1,
								description: "Oversized package option"
							},
							no_tracking: {
								type: "object",
								additionalProperties: !1,
								description: "Ship without track and trace option"
							},
							only_recipient: {
								type: "object",
								additionalProperties: !1,
								description: "Recipient only delivery option"
							},
							priority_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Priority delivery option"
							},
							receipt_code: {
								type: "object",
								additionalProperties: !1,
								description: "Requires receipt code option"
							},
							return: {
								type: "object",
								additionalProperties: !1,
								description: "Return on first failed delivery option"
							},
							same_day_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Same day delivery option"
							},
							saturday_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Saturday delivery option"
							},
							signature: {
								type: "object",
								additionalProperties: !1,
								description: "Requires signature option"
							},
							tracked: {
								type: "object",
								additionalProperties: !1,
								description: "DEPRECATED: replaced by no_tracking (its inverse)."
							},
							insurance: {
								oneOf: [{
									type: "object",
									required: ["insured_amount"],
									additionalProperties: !1,
									properties: { insured_amount: { $ref: "#/components/schemas/_ref_types_money" } },
									description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release."
								}, { $ref: "#/components/schemas/_ref_types_money" }],
								description: "Insurance option. Provide the insured amount as flat {amount, currency} (recommended) or via the deprecated nested {insured_amount: Money} form."
							}
						}
					},
					delivery_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					shipment_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					direction: {
						type: "string",
						enum: ["INBOUND", "OUTBOUND"],
						description: "The shipment direction for which the rates are requested."
					},
					collo: {
						type: "integer",
						minimum: 1,
						description: "The number of collo for which the rates are requested."
					}
				}
			}
		} }
	} }
}, Jh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "POST notification groups",
	type: "object",
	oneOf: [{
		type: "object",
		required: [
			"shopId",
			"packageType",
			"countryCode",
			"shipmentDirection"
		],
		properties: {
			shopId: { type: "integer" },
			packageType: {
				type: "string",
				enum: [
					"DIGITAL_STAMP",
					"ENVELOPE",
					"UNFRANKED",
					"MAILBOX",
					"PACKAGE",
					"PALLET",
					"SMALL_PACKAGE"
				]
			},
			countryCode: {
				type: "string",
				minLength: 2,
				maxLength: 2,
				pattern: "^[A-Z]{2}$",
				description: "ISO 3166-1 alpha-2 country code"
			},
			shipmentDirection: {
				type: "string",
				enum: ["OUTBOUND"]
			}
		},
		additionalProperties: !1
	}, {
		type: "object",
		required: ["shopId", "shipmentDirection"],
		properties: {
			shopId: { type: "integer" },
			packageType: { type: "null" },
			countryCode: {
				type: "string",
				minLength: 2,
				maxLength: 2,
				pattern: "^[A-Z]{2}$",
				description: "ISO 3166-1 alpha-2 country code"
			},
			shipmentDirection: {
				type: "string",
				enum: ["INBOUND"]
			}
		},
		additionalProperties: !1
	}]
}, Yh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "PUT notification templates",
	type: "object",
	required: ["body", "subject"],
	properties: {
		body: {
			type: "string",
			minLength: 1
		},
		subject: {
			type: "string",
			minLength: 1,
			maxLength: 255
		}
	},
	additionalProperties: !1
}, Xh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Webhook subscriptions V1.1",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { webhook_subscriptions: {
			type: "array",
			minItems: 1,
			items: { $ref: "#/components/schemas/_ref_webhook_webhook-v1.1" }
		} }
	} }
}, Zh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["hook", "url"],
	additionalProperties: !1,
	properties: {
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" },
		payload: { type: ["string", "null"] }
	}
}, Qh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Webhook subscriptions",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { webhook_subscriptions: {
			type: "array",
			minItems: 1,
			items: { $ref: "#/components/schemas/_ref_webhook_webhook-v1.0" }
		} }
	} }
}, $h = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["hook", "url"],
	additionalProperties: !1,
	properties: {
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" }
	}
}, eg = ["PNPNL-01", "PNPBE-01"], z = (e) => {
	let t = Object.values(I).find((t) => t === e.location_type);
	return t ? F(t) : void 0;
}, B = (e) => {
	if (!e) return;
	let t = eg.find((t) => t === e.retail_network_id?.toUpperCase()), n = z(e);
	return {
		address: {
			city: e.city || void 0,
			countryCode: e.cc ?? "",
			street: e.street || void 0,
			houseNumber: e.number || void 0,
			postalCode: e.postal_code || void 0
		},
		location: {
			name: e.location_name ?? "",
			code: e.location_code || void 0,
			...n ? { type: n } : {}
		},
		...t ? { retailNetworkId: t } : {}
	};
}, V = (e) => {
	if (!e) return;
	let t = z(e);
	return t ? { location: { type: t } } : void 0;
}, tg = new Set(Object.values(P)), H = (e) => {
	let t = Vl(e);
	return tg.has(t) ? t : void 0;
}, ng = new Set(Object.values(j)), U = (e) => {
	if (!e?.delivery_type) return;
	let t = Hl(e.delivery_type);
	return ng.has(t) ? t : void 0;
}, rg = [M.RETURN, M.RETURN_ERS], W = (e) => rg.some((t) => t === e) ? "INBOUND" : "OUTBOUND", G = (e) => ({
	countryCode: e.cc ?? "",
	...e.postal_code ? { postalCode: e.postal_code } : {},
	...e.company ? { isBusiness: !0 } : {}
}), K = (e) => e ? {
	unit: "mm",
	value: e * 10
} : void 0, ig = (e) => e ? {
	unit: "g",
	value: e
} : void 0, q = (e) => {
	let t = {
		height: K(e?.height),
		length: K(e?.length),
		weight: ig(e?.weight),
		width: K(e?.width)
	};
	return Object.values(t).some(Boolean) ? t : void 0;
}, J = {
	age_check: "requiresAgeVerification",
	collect: "requiresCashOnDelivery",
	drop_off_at_postal_point: "deliverAtPostalPoint",
	extra_assurance: "additionalInsurance",
	fresh_food: "freshFood",
	frozen: "frozen",
	hide_sender: "hideSender",
	large_format: "oversizedPackage",
	only_recipient: "recipientOnlyDelivery",
	printerless_return: "printReturnLabelAtDropOff",
	priority_delivery: "priorityDelivery",
	receipt_code: "requiresReceiptCode",
	return: "returnOnFirstFailedDelivery",
	same_day_delivery: "sameDayDelivery",
	saturday_delivery: "saturdayDelivery",
	signature: "requiresSignature"
}, ag = ["collect", "printerless_return"], Y = (e, t = []) => Object.fromEntries(Object.keys(J).filter((n) => !t.includes(n) && e[n]).map((e) => [J[e], {}])), X = (e) => ({
	currency: e.currency,
	amount: e.amount
}), Z = (e) => {
	if (!e) return;
	let t = Y(e);
	return e.insurance && (t.insurance = X(e.insurance)), e.tracked === 0 && (t.noTracking = {}), Object.keys(t).length > 0 ? t : void 0;
}, Q = (e) => {
	if (!e) return;
	let t = Y(e, ag);
	return e.insurance && (t.insurance = X(e.insurance)), e.tracked === 0 && (t.noTracking = {}), Object.keys(t).length > 0 ? t : void 0;
}, og = (e) => ({
	shopId: e.shop_id,
	...e.contract_id ? { contractId: e.contract_id } : {},
	recipient: G(e.recipient),
	...e.sender ? { sender: G(e.sender) } : {},
	carrier: H(e.carrier_id),
	...e.options?.package_type ? { packageType: R(e.options.package_type) } : {},
	physicalProperties: q(e.physical_properties),
	options: Z(e.options),
	deliveryType: U(e.options),
	pickup: V(e.pickup),
	direction: W(e.shipment_type)
}), sg = (e) => {
	let t = H(e.carrier_id);
	if (!t) return;
	let n = e.options?.package_type ?? zl.Package;
	return {
		shopId: e.shop_id,
		...e.contract_id ? { contractId: e.contract_id } : {},
		recipient: G(e.recipient),
		...e.sender ? { sender: G(e.sender) } : {},
		pickup: B(e.pickup),
		carrier: t,
		packageType: R(n),
		physicalProperties: q(e.physical_properties),
		options: Q(e.options),
		deliveryType: U(e.options),
		direction: W(e.shipment_type)
	};
}, $ = (e) => typeof e == "object" && !!e && !Array.isArray(e), cg = (e) => $(e) && "data" in e && $(e.data), lg = (e) => e.data, ug = (e) => $(e) && Array.isArray(e.errors) && e.errors.some((e) => $(e) && Object.keys(e).some((e) => /^\d+$/.test(e))), dg = (e) => e.errors.flatMap((e) => Object.keys(e).filter((e) => /^\d+$/.test(e)).map(Number)), fg = (e) => {
	if (!$(e) || !("errors" in e)) return !1;
	let { errors: t } = e;
	return Array.isArray(t) || $(t);
}, pg = (e) => (Array.isArray(e.errors) ? e.errors : Object.values(e.errors)).filter($).map((e) => e.code).filter((e) => typeof e == "number"), mg = (e) => $(e) && typeof e.code == "number", hg = (e) => [e.code], gg = (e) => {
	let t = cg(e) ? lg(e) : e;
	return ug(t) ? dg(t) : fg(t) ? pg(t) : mg(t) ? hg(t) : [];
}, _g = {
	[L.EarlyMorning]: j.EARLY_MORNING,
	[L.Morning]: j.MORNING,
	[L.Standard]: j.STANDARD,
	[L.Evening]: j.EVENING,
	[L.Pickup]: j.PICKUP,
	[L.PickupExpress]: j.PICKUP,
	[L.SameDayDelivery]: j.SAME_DAY,
	[L.Express]: j.EXPRESS
}, vg = (e) => {
	if (e) return _g[e];
}, yg = (e) => {
	switch (e.unit) {
		case "g": return e.value;
		case "kg": return e.value * Ul.getWeightFactor(Bl.Kilogram);
		default: throw Error(`Unsupported unit: ${e.unit}`);
	}
};
//#endregion
export { yl as AccountDefsPlatformId, fl as AccountDefsPlatformName, wl as AccountParametersPlatformId, Ol as BillingDefsCurrency, pl as CommonDefsDayOfWeek, Sl as CommonDefsIsoDayOfWeek, jl as CommonDefsTimeZoneType, ml as CommonErrorUserCodeAuth, gl as CommonHttpStatusCode4XxClientError400BadRequest, Tl as CommonHttpStatusCode4XxClientError401Unauthorized, Cl as CommonHttpStatusCode4XxClientError404NotFound, vl as CommonHttpStatusCode4XxClientError406NotAcceptable, _l as CommonHttpStatusCode4XxClientError415UnsupportedMediaType, dl as CommonParametersFilterValidateBool, Ml as CommonParametersOrder, Pl as RefCapabilitiesSharedCarrier, P as RefCapabilitiesSharedCarrierV2, Nl as RefNotificationNotificationTemplateType, il as RefShipmentBpostBpostPugoType, Wc as RefShipmentLabelPrintingPosition, I as RefShipmentLocationType, al as RefShipmentLocationTypeV2, Kc as RefShipmentPackageType, Gc as RefShipmentPackageType1Package, el as RefShipmentPackageType2Mailbox, xl as RefShipmentPackageType6SmallPackage, Hc as RefShipmentPackageTypeV2, bl as RefShipmentShipmentTypeV2, $c as RefShipmentTransactionStatus, M as RefShipmentType, tl as RefTypesCarrier, qc as RefTypesCarrierReturns, Xc as RefTypesDeliveryType, j as RefTypesDeliveryTypeV2, rl as RefTypesIntBoolean, Fl as RefTypesMoneyPropertiesCurrency, Uc as RefTypesShipmentType, N as RefTypesTransactionTypes, Yc as ShipmentDefsCustomsShipmentType, ol as ShipmentDefsDeliveryMomentPropertiesType, sl as ShipmentDefsDeliveryOptionsDeliveryNameV2, Jc as ShipmentDefsExternalProviderPropertiesDisplayName, Qc as ShipmentDefsMainStatus, El as ShipmentDefsShipmentPaymentStatus, Zc as ShipmentDefsShipmentStatus, kl as ShipmentOptions, ll as ShipmentParametersCarrierId, cl as ShipmentParametersCarrierName, ul as ShipmentParametersDeliveryType, nl as ShipmentParametersPaperSize, Vc as ShipmentParametersSortShipment, hl as ShipmentResponsesDeliveryOptionsPackageTypeV2, Al as SortTracktraces, mm as _ref_capabilities_contract_definitions_response_contract_definitions_v1Schema, lm as _ref_capabilities_contract_definitions_response_contract_definitions_v2Schema, _m as _ref_capabilities_contract_definitions_response_options_insurance_option_v1Schema, fm as _ref_capabilities_contract_definitions_response_options_insurance_option_v2Schema, gm as _ref_capabilities_contract_definitions_response_options_option_v1Schema, dm as _ref_capabilities_contract_definitions_response_options_option_v2Schema, hm as _ref_capabilities_contract_definitions_response_options_options_v1Schema, um as _ref_capabilities_contract_definitions_response_options_options_v2Schema, Qp as _ref_capabilities_response_capability_v1Schema, Fp as _ref_capabilities_response_capability_v2Schema, Xp as _ref_capabilities_response_colloSchema, am as _ref_capabilities_response_options_insurance_option_v1Schema, Up as _ref_capabilities_response_options_insurance_option_v2Schema, im as _ref_capabilities_response_options_option_v1Schema, Hp as _ref_capabilities_response_options_option_v2Schema, tm as _ref_capabilities_response_options_options_v1Schema, zp as _ref_capabilities_response_options_options_v2Schema, sm as _ref_capabilities_response_physical_properties_physical_properties_v1Schema, Gp as _ref_capabilities_response_physical_properties_physical_properties_v2Schema, Kp as _ref_capabilities_response_physical_properties_physical_propertySchema, $p as _ref_capabilities_shared_carrierSchema, Ip as _ref_capabilities_shared_carrier_v2Schema, em as _ref_capabilities_shared_contract_v1Schema, Lp as _ref_capabilities_shared_contract_v2Schema, rm as _ref_capabilities_shared_options_base_option_v1Schema, Vp as _ref_capabilities_shared_options_base_option_v2Schema, nm as _ref_capabilities_shared_options_base_options_v1Schema, Bp as _ref_capabilities_shared_options_base_options_v2Schema, om as _ref_capabilities_shared_options_insurance_base_insurance_v1Schema, Wp as _ref_capabilities_shared_options_insurance_base_insurance_v2Schema, Nm as _ref_notification_notification_template_typeSchema, Am as _ref_notification_response_notification_groupSchema, Mm as _ref_notification_response_notification_templateSchema, Tm as _ref_rates_response_contractSchema, ym as _ref_rates_response_contract_v2Schema, Dm as _ref_rates_response_price_composition_price_composition_v1Schema, xm as _ref_rates_response_price_composition_price_composition_v2Schema, Om as _ref_rates_response_price_composition_price_v1Schema, Sm as _ref_rates_response_price_composition_price_v2Schema, wm as _ref_rates_response_rate_v1Schema, vm as _ref_rates_response_rate_v2Schema, Gh as _ref_shipment_address_v2Schema, wu as _ref_shipment_bpost_bpost_pugo_typeSchema, Tu as _ref_shipment_customs_declarationSchema, Du as _ref_shipment_customs_declaration_itemSchema, xu as _ref_shipment_general_settingsSchema, uh as _ref_shipment_label_printing_positionSchema, Cu as _ref_shipment_location_typeSchema, zh as _ref_shipment_location_type_v2Schema, Kh as _ref_shipment_location_v2Schema, vu as _ref_shipment_options_delivery_type_allSchema, yu as _ref_shipment_options_delivery_type_delivery_dateSchema, du as _ref_shipment_options_insuranceSchema, uu as _ref_shipment_options_insurance_maxSchema, bu as _ref_shipment_options_label_descriptionSchema, pu as _ref_shipment_options_optionsSchema, Mh as _ref_shipment_options_options_returnsSchema, gu as _ref_shipment_options_package_type_allSchema, Oh as _ref_shipment_options_package_type_returnsSchema, _u as _ref_shipment_package_typeSchema, kh as _ref_shipment_package_type_1_packageSchema, Ah as _ref_shipment_package_type_2_mailboxSchema, jh as _ref_shipment_package_type_6_small_packageSchema, Rp as _ref_shipment_package_type_v2Schema, Au as _ref_shipment_physical_properties_properties_heightSchema, Mu as _ref_shipment_physical_properties_properties_lengthSchema, Nu as _ref_shipment_physical_properties_properties_volumeSchema, ku as _ref_shipment_physical_properties_properties_weightSchema, ju as _ref_shipment_physical_properties_properties_widthSchema, wh as _ref_shipment_pickupSchema, Wh as _ref_shipment_pickup_v2Schema, Sh as _ref_shipment_recipient_secondary_emailsSchema, zu as _ref_shipment_reference_identifierSchema, Ch as _ref_shipment_senderSchema, lu as _ref_shipment_shipment_optionsSchema, Dh as _ref_shipment_shipment_options_returnsSchema, bm as _ref_shipment_shipment_type_v2Schema, Bu as _ref_shipment_transaction_statusSchema, nu as _ref_shipment_typeSchema, Ju as _ref_types_carrierSchema, Nh as _ref_types_carrier_returnsSchema, au as _ref_types_ccSchema, zf as _ref_types_delivery_typeSchema, Jp as _ref_types_delivery_type_v2Schema, mu as _ref_types_int_booleanSchema, hu as _ref_types_moneySchema, Hu as _ref_types_money_nullable_amountSchema, Wu as _ref_types_money_properties_amountSchema, Uu as _ref_types_money_properties_currencySchema, fu as _ref_types_price_euroSchema, Em as _ref_types_shipment_typeSchema, Yp as _ref_types_transaction_typesSchema, qp as _ref_types_value_with_unitSchema, $h as _ref_webhook_webhook_v1_0Schema, Zh as _ref_webhook_webhook_v1_1Schema, eu as account_defs_account_properties_idSchema, Ed as account_defs_contactSchema, ou as account_defs_contact_properties_emailSchema, Fd as account_defs_location_properties_box_numberSchema, Nd as account_defs_location_properties_ccSchema, Md as account_defs_location_properties_citySchema, kd as account_defs_location_properties_numberSchema, Ad as account_defs_location_properties_number_suffixSchema, jd as account_defs_location_properties_postal_codeSchema, Pd as account_defs_location_properties_regionSchema, Dd as account_defs_location_properties_streetSchema, Od as account_defs_location_properties_street_additional_infoSchema, Xu as account_defs_platform_idSchema, sh as account_defs_platform_nameSchema, Yu as account_defs_platform_properties_idSchema, tu as account_defs_shop_properties_idSchema, uf as account_defs_user_properties_idSchema, ch as account_parameters_platform_idSchema, oh as account_parameters_platform_identifierSchema, Ud as billing_defs_currencySchema, yf as billing_defs_payment_dataSchema, _f as billing_defs_shipment_dataSchema, V as buildCapabilitiesPickup, og as buildCapabilitiesRequest, B as buildRatesPickup, sg as buildRatesRequest, H as buildRequestCarrier, U as buildRequestDeliveryType, W as buildRequestDirection, G as buildRequestLocation, q as buildRequestPhysicalProperties, Bh as capabilities_post_capabilities_request_v1Schema, Rh as capabilities_post_capabilities_request_v2Schema, Hh as capabilities_post_contract_definitions_request_v1Schema, Vh as capabilities_post_contract_definitions_request_v2Schema, Zp as capabilities_responses_capabilities_v1Schema, Pp as capabilities_responses_capabilities_v2Schema, pm as capabilities_responses_contract_definitions_v1Schema, cm as capabilities_responses_contract_definitions_v2Schema, Pf as common_defs_dateSchema, af as common_defs_date_and_timeSchema, Ef as common_defs_date_timeSchema, ep as common_defs_day_of_weekSchema, Xf as common_defs_download_urlSchema, tp as common_defs_iso_day_of_weekSchema, Hf as common_defs_latitudeSchema, Uf as common_defs_longitudeSchema, bf as common_defs_priceSchema, If as common_defs_timeSchema, Df as common_defs_time_zone_typeSchema, rf as common_defs_timestamps_properties_createdSchema, lf as common_defs_timestamps_properties_created_bySchema, sf as common_defs_timestamps_properties_modifiedSchema, ff as common_defs_timestamps_properties_modified_bySchema, Sp as common_error_systemSchema, ql as common_error_userSchema, Jl as common_error_user_codeSchema, Yl as common_error_user_code_authSchema, Kl as common_http_status_code_4xx_client_errorSchema, Sf as common_http_status_code_4xx_client_error_400_bad_requestSchema, lp as common_http_status_code_4xx_client_error_401_unauthorizedSchema, Xl as common_http_status_code_4xx_client_error_404_not_foundSchema, Jf as common_http_status_code_4xx_client_error_406_not_acceptableSchema, sp as common_http_status_code_4xx_client_error_415_unsupported_media_typeSchema, Kf as common_http_status_code_5xx_server_errorSchema, Gf as common_http_status_code_errorSchema, ph as common_parameters_bigidSchema, fh as common_parameters_bigidsSchema, Km as common_parameters_booleanSchema, Wm as common_parameters_country_codeSchema, qm as common_parameters_filter_validate_boolSchema, gh as common_parameters_idSchema, hh as common_parameters_idsSchema, th as common_parameters_latitudeSchema, nh as common_parameters_longitudeSchema, rh as common_parameters_orderSchema, ah as common_parameters_pageSchema, _h as common_parameters_sizeSchema, Zm as common_parameters_weekday_digitSchema, mf as common_responses_download_linkSchema, hf as common_responses_download_link_definitions_urlSchema, Yf as common_responses_download_urlSchema, Cf as common_responses_problemSchema, xp as common_responses_system_errorSchema, Gl as common_responses_user_errorSchema, xf as common_responses_user_error_bad_requestSchema, op as common_responses_user_error_invalid_content_typeSchema, qf as common_responses_user_error_not_acceptableSchema, Wl as common_responses_user_error_not_foundSchema, cp as common_responses_user_error_permission_deniedSchema, As as coreApiAcceptanceUrl, To as coreApiUrl, Aa as deleteNotificationGroups, oi as deleteShipments, Fo as deleteWebhookSubscriptions, bs as disableAllNotificationTemplatesByGroup, Ti as disableNotificationTemplate, io as enableAllNotificationTemplatesByGroup, Bs as enableNotificationTemplate, Wf as errorSchema, Fi as getDeliveryOptions, ea as getDropOffPoints, gg as getErrorCodes, Go as getIndex, ho as getNotificationGroups, ba as getNotificationTemplates, ua as getPickupLocations, Zr as getShipments, Xs as getShipmentsById, Cc as getShipmentsLabels, gi as getTrackTraces, mc as getTrackTracesByIds, Nn as getWebhookSubscriptions, r as getWebhookSubscriptionsById, vg as mapAdjustedDeliveryType, F as mapPickupLocationTypeV1ToV2, Dl as mapPickupLocationTypeV2ToV1, yg as mapServiceWeightToGrams, Y as mapShipmentOptionFlags, Z as mapShipmentOptionsToCapabilities, Q as mapShipmentOptionsToRates, Jh as notification_post_notification_group_requestSchema, Yh as notification_put_notification_template_requestSchema, km as notification_responses_notification_groupsSchema, jm as notification_responses_notification_templatesSchema, ef as order_defs_shipped_item_properties_order_lineSchema, $d as order_defs_shipped_item_properties_order_line_identifierSchema, tf as order_defs_shipped_item_properties_picklist_identifierSchema, Qd as order_defs_shipped_item_properties_quantitySchema, ac as patchShipments, Hn as postCapabilities, x as postCapabilitiesContractDefinitions, f as postNotificationGroups, Xt as postRates, Ya as postShipments, oe as postUnrelatedReturnShipments, Ba as postWebhookSubscriptions, Mt as putNotificationTemplate, Vt as putShipment, qh as rates_post_rates_request_v1Schema, Uh as rates_post_rates_request_v2Schema, Cm as rates_responses_rates_v1Schema, us as resolveCoreApiBaseUrl, on as sendTestNotification, J as shipmentOptionFlagMapV1ToV2, Ap as shipment_defs_carrier_track_trace_eventSchema, kp as shipment_defs_carrier_track_trace_historySchema, Eu as shipment_defs_customs_shipment_typeSchema, Mp as shipment_defs_delivery_moment_properties_time_frameSchema, jp as shipment_defs_delivery_moment_properties_typeSchema, kf as shipment_defs_delivery_options_delivery_name_v2Schema, jf as shipment_defs_delivery_options_delivery_time_frameSchema, Bf as shipment_defs_delivery_options_opening_hoursSchema, Vf as shipment_defs_delivery_options_opening_hours_definitions_opening_hoursSchema, Lf as shipment_defs_delivery_options_pickupSchema, Rf as shipment_defs_delivery_options_pickup_timeSchema, Gu as shipment_defs_external_provider_properties_display_nameSchema, Ku as shipment_defs_external_provider_properties_idSchema, Ep as shipment_defs_external_track_trace_linkSchema, Op as shipment_defs_main_statusSchema, np as shipment_defs_occupancySchema, Ql as shipment_defs_shipmentSchema, Rd as shipment_defs_shipment_carrier_properties_external_identifierSchema, Vu as shipment_defs_shipment_drop_off_pointSchema, Zu as shipment_defs_shipment_origin_properties_originSchema, Qu as shipment_defs_shipment_origin_properties_user_agentSchema, qd as shipment_defs_shipment_partner_tracktracesSchema, qu as shipment_defs_shipment_payment_statusSchema, Ou as shipment_defs_shipment_physical_propertiesSchema, Fu as shipment_defs_shipment_physical_properties_properties_heightSchema, Lu as shipment_defs_shipment_physical_properties_properties_lengthSchema, Ru as shipment_defs_shipment_physical_properties_properties_volumeSchema, Pu as shipment_defs_shipment_physical_properties_properties_weightSchema, Iu as shipment_defs_shipment_physical_properties_properties_widthSchema, Su as shipment_defs_shipment_pickupSchema, ed as shipment_defs_shipment_properties_account_idSchema, Vd as shipment_defs_shipment_properties_amountSchema, gd as shipment_defs_shipment_properties_barcodeSchema, xd as shipment_defs_shipment_properties_carrier_idSchema, Td as shipment_defs_shipment_properties_collection_contactSchema, Wd as shipment_defs_shipment_properties_contract_idSchema, nf as shipment_defs_shipment_properties_createdSchema, cf as shipment_defs_shipment_properties_created_bySchema, Hd as shipment_defs_shipment_properties_currencySchema, ld as shipment_defs_shipment_properties_customs_declarationSchema, zd as shipment_defs_shipment_properties_delayedSchema, Bd as shipment_defs_shipment_properties_deliveredSchema, pd as shipment_defs_shipment_properties_drop_off_pointSchema, Ld as shipment_defs_shipment_properties_external_identifierSchema, vd as shipment_defs_shipment_properties_external_providerSchema, yd as shipment_defs_shipment_properties_external_provider_idSchema, sd as shipment_defs_shipment_properties_general_settingsSchema, md as shipment_defs_shipment_properties_hiddenSchema, $l as shipment_defs_shipment_properties_idSchema, Gd as shipment_defs_shipment_properties_link_consumer_portalSchema, of as shipment_defs_shipment_properties_modifiedSchema, df as shipment_defs_shipment_properties_modified_bySchema, Id as shipment_defs_shipment_properties_multi_collo_main_shipment_idSchema, od as shipment_defs_shipment_properties_optionsSchema, Yd as shipment_defs_shipment_properties_order_shipment_identifierSchema, Cd as shipment_defs_shipment_properties_originSchema, $u as shipment_defs_shipment_properties_parent_idSchema, Kd as shipment_defs_shipment_properties_partner_tracktracesSchema, bd as shipment_defs_shipment_properties_payment_statusSchema, ud as shipment_defs_shipment_properties_physical_propertiesSchema, cd as shipment_defs_shipment_properties_pickupSchema, Jd as shipment_defs_shipment_properties_pickup_request_numberSchema, Sd as shipment_defs_shipment_properties_platform_idSchema, hd as shipment_defs_shipment_properties_priceSchema, rd as shipment_defs_shipment_properties_recipientSchema, dd as shipment_defs_shipment_properties_reference_identifierSchema, _d as shipment_defs_shipment_properties_regionSchema, id as shipment_defs_shipment_properties_senderSchema, nd as shipment_defs_shipment_properties_shipment_typeSchema, Xd as shipment_defs_shipment_properties_shipped_itemsSchema, td as shipment_defs_shipment_properties_shop_idSchema, ad as shipment_defs_shipment_properties_statusSchema, fd as shipment_defs_shipment_properties_transaction_statusSchema, wd as shipment_defs_shipment_properties_user_agentSchema, ru as shipment_defs_shipment_recipientSchema, iu as shipment_defs_shipment_senderSchema, su as shipment_defs_shipment_sender_properties_emailSchema, Zd as shipment_defs_shipment_shipped_itemSchema, cu as shipment_defs_shipment_statusSchema, Tp as shipment_defs_track_traceSchema, Np as shipment_defs_track_trace_proof_of_deliverySchema, Dp as shipment_defs_tracking_locationSchema, zm as shipment_parameters_barcodeSchema, Vm as shipment_parameters_carrier_idSchema, Bm as shipment_parameters_carrier_identifierSchema, Hm as shipment_parameters_carrier_nameSchema, Um as shipment_parameters_collect_dateSchema, Gm as shipment_parameters_cutoff_timeSchema, Jm as shipment_parameters_delivery_dateSchema, Xm as shipment_parameters_delivery_options_identifierSchema, Ym as shipment_parameters_delivery_timeSchema, $m as shipment_parameters_delivery_typeSchema, Qm as shipment_parameters_delivery_typesSchema, lh as shipment_parameters_label_positionSchema, ih as shipment_parameters_package_typeSchema, eh as shipment_parameters_paper_sizeSchema, dh as shipment_parameters_postal_codeSchema, mh as shipment_parameters_shipment_typeSchema, vh as shipment_parameters_sort_shipmentSchema, yh as shipment_parameters_statusSchema, bh as shipment_parameters_tracktraces_extra_infoSchema, Lh as shipment_patch_shipments_requestSchema, Eh as shipment_post_return_shipments_requestSchema, Th as shipment_post_shipments_requestSchema, xh as shipment_post_shipments_request_v1_1Schema, Ph as shipment_post_unrelated_return_shipments_requestSchema, Ih as shipment_put_shipments_requestSchema, Fh as shipment_put_shipments_request_v1_1Schema, gf as shipment_responses_bulk_shipment_labels_payment_requiredSchema, Nf as shipment_responses_delivery_options_delivery_option_v1Schema, Tf as shipment_responses_delivery_options_delivery_option_v2Schema, Of as shipment_responses_delivery_options_delivery_possibilitySchema, Ff as shipment_responses_delivery_options_delivery_timeSchema, Af as shipment_responses_delivery_options_package_type_v2Schema, Mf as shipment_responses_delivery_options_v1Schema, wf as shipment_responses_delivery_options_v2Schema, pf as shipment_responses_downloadable_labelSchema, Qf as shipment_responses_drop_off_pointSchema, $f as shipment_responses_drop_off_point_definitions_available_daysSchema, rp as shipment_responses_drop_off_point_definitions_opening_hoursSchema, ap as shipment_responses_drop_off_point_definitions_timeframeSchema, ip as shipment_responses_drop_off_point_definitions_timeframesSchema, Zf as shipment_responses_drop_off_pointsSchema, vf as shipment_responses_payment_instructionsSchema, up as shipment_responses_pickup_locationsSchema, fp as shipment_responses_pickup_locations_definitions_addressSchema, mp as shipment_responses_pickup_locations_definitions_locationSchema, hp as shipment_responses_pickup_locations_definitions_opening_hoursSchema, dp as shipment_responses_pickup_locations_definitions_pickup_locationSchema, pp as shipment_responses_pickup_locations_definitions_possibilitiesSchema, gp as shipment_responses_pickup_locations_definitions_timeframeSchema, _p as shipment_responses_post_shipments_v1_2Schema, Zl as shipment_responses_put_shipments_v1_2Schema, vp as shipment_responses_shipment_idsSchema, bp as shipment_responses_shipment_ids_properties_data_properties_idsSchema, yp as shipment_responses_shipment_labelsSchema, Cp as shipment_responses_shipmentsSchema, wp as shipment_responses_tracktracesSchema, Ll as useCoreApiService, Il as useShipmentCapabilitiesService, Rl as useShipmentPricingService, Qh as webhooks_post_webhook_subscriptions_request_v1_0Schema, Xh as webhooks_post_webhook_subscriptions_request_v1_1Schema, Rm as webhooks_responses_post_webhook_subscriptionsSchema, Im as webhooks_responses_webhook_subscriptions_v1_0Schema, Pm as webhooks_responses_webhook_subscriptions_v1_1Schema, Lm as webhooks_responses_webhook_v1_0Schema, Fm as webhooks_responses_webhook_v1_1Schema, A as zAccountDefsAccountPropertiesId, Xe as zAccountDefsContact, Ct as zAccountDefsContactPropertiesEmail, wn as zAccountDefsLocationPropertiesBoxNumber, Mc as zAccountDefsLocationPropertiesCc, he as zAccountDefsLocationPropertiesCity, or as zAccountDefsLocationPropertiesNumber, Ve as zAccountDefsLocationPropertiesNumberSuffix, Zn as zAccountDefsLocationPropertiesPostalCode, hr as zAccountDefsLocationPropertiesRegion, Me as zAccountDefsLocationPropertiesStreet, mt as zAccountDefsLocationPropertiesStreetAdditionalInfo, ts as zAccountDefsPlatformId, at as zAccountDefsPlatformName, Nr as zAccountDefsPlatformPropertiesId, wr as zAccountDefsShopPropertiesId, Hr as zAccountDefsUserPropertiesId, hn as zAccountParametersPlatformId, e as zAccountParametersPlatformIdentifier, $i as zBarcode, zs as zBillingDefsCurrency, Po as zBillingDefsPaymentData, ys as zBillingDefsShipmentData, za as zCapabilitiesPostCapabilitiesRequestV1, hi as zCapabilitiesPostCapabilitiesRequestV2, Wo as zCapabilitiesPostContractDefinitionsRequestV1, ks as zCapabilitiesPostContractDefinitionsRequestV2, Pi as zCapabilitiesResponsesCapabilitiesV1, mo as zCapabilitiesResponsesCapabilitiesV2, Ys as zCapabilitiesResponsesContractDefinitionsV1, Wi as zCapabilitiesResponsesContractDefinitionsV2, la as zCarrier, es as zCarrierId, wo as zCc, ka as zCity, ya as zCollectDate, ai as zCommonDefsDate, ic as zCommonDefsDateAndTime, jc as zCommonDefsDateTime, wi as zCommonDefsDayOfWeek, Sc as zCommonDefsDownloadUrl, Vn as zCommonDefsIsoDayOfWeek, d as zCommonDefsLatitude, pc as zCommonDefsLongitude, Xn as zCommonDefsPrice, k as zCommonDefsTime, b as zCommonDefsTimeZoneType, an as zCommonDefsTimestampsPropertiesCreated, ro as zCommonDefsTimestampsPropertiesCreatedBy, me as zCommonDefsTimestampsPropertiesModified, Ja as zCommonDefsTimestampsPropertiesModifiedBy, Bt as zCommonErrorSystem, Yt as zCommonErrorUser, mn as zCommonErrorUserCode, je as zCommonErrorUserCodeAuth, it as zCommonHttpStatusCode4XxClientError, jt as zCommonHttpStatusCode4XxClientError400BadRequest, Mn as zCommonHttpStatusCode4XxClientError401Unauthorized, Bc as zCommonHttpStatusCode4XxClientError404NotFound, Ce as zCommonHttpStatusCode4XxClientError406NotAcceptable, mr as zCommonHttpStatusCode4XxClientError415UnsupportedMediaType, Ye as zCommonHttpStatusCode5XxServerError, ar as zCommonHttpStatusCodeError, Cr as zCommonParametersBigid, Be as zCommonParametersBigids, St as zCommonParametersBoolean, ls as zCommonParametersCountryCode, pt as zCommonParametersFilterValidateBool, Vr as zCommonParametersId, Mr as zCommonParametersIds, Xr as zCommonParametersLatitude, Cn as zCommonParametersLongitude, ae as zCommonParametersOrder, Yi as zCommonParametersPage, Fs as zCommonParametersSize, Ao as zCommonParametersWeekdayDigit, hs as zCommonResponsesDownloadLink, Fa as zCommonResponsesDownloadLinkDefinitionsUrl, di as zCommonResponsesDownloadUrl, Bo as zCommonResponsesProblem, Ts as zCommonResponsesSystemError, Ai as zCommonResponsesUserError, lo as zCommonResponsesUserErrorBadRequest, Gs as zCommonResponsesUserErrorInvalidContentType, Bi as zCommonResponsesUserErrorNotAcceptable, aa as zCommonResponsesUserErrorNotFound, Xo as zCommonResponsesUserErrorPermissionDenied, bo as zCountryCode, Ta as zCreated, ha as zCutOffTime, ti as zCutoffTime, ec as zDelayed, Dc as zDeleteNotificationGroupsData, bi as zDeleteNotificationGroupsResponse, vc as zDeleteShipmentsData, Ln as zDeleteShipmentsResponse, s as zDeleteWebhookSubscriptionsData, lc as zDeleteWebhookSubscriptionsResponse, Kn as zDelivered, T as zDeliveryDate, g as zDeliveryOptionsIdentifier, en as zDeliveryTime, $a as zDeliverydaysWindow, ue as zDisableAllNotificationTemplatesByGroupData, Wa as zDisableAllNotificationTemplatesByGroupResponse, It as zDisableNotificationTemplateData, Gt as zDisableNotificationTemplateResponse, un as zDistance, De as zDropoffDays, et as zDropoffDelay, Dt as zDropoffToday, On as zEnableAllNotificationTemplatesByGroupData, Ic as zEnableAllNotificationTemplatesByGroupResponse, ye as zEnableNotificationTemplateData, ur as zEnableNotificationTemplateResponse, Ge as zError, tr as zExcludeDeliveryType, yr as zExcludeParcelLockers, Ie as zExternalIdentifier, vt as zExtraInfoTracktraces, as as zFilterHiddenShops, lt as zFormat, Lr as zGetDeliveryOptionsData, Or as zGetDeliveryOptionsResponse, Kr as zGetDropOffPointsData, yn as zGetDropOffPointsResponse, te as zGetIndexData, Zi as zGetIndexResponse, Ls as zGetNotificationGroupsData, Mo as zGetNotificationGroupsResponse, _s as zGetNotificationTemplatesData, La as zGetNotificationTemplatesResponse, pi as zGetPickupLocationsData, Ho as zGetPickupLocationsResponse, Ds as zGetShipmentsByIdData, Mi as zGetShipmentsByIdResponse, fo as zGetShipmentsData, qs as zGetShipmentsLabelsData, Hi as zGetShipmentsLabelsResponse, sa as zGetShipmentsResponse, Qo as zGetTrackTracesByIdsData, So as zGetTrackTracesByIdsResponse, Da as zGetTrackTracesData, _a as zGetTrackTracesResponse, ri as zGetWebhookSubscriptionsByIdData, nc as zGetWebhookSubscriptionsByIdResponse, kc as zGetWebhookSubscriptionsData, Si as zGetWebhookSubscriptionsResponse, bc as zHidden, zn as zHook, l as zIncludeSecondaryShipments, dc as zLatitude, Jn as zLimit, D as zLinkConsumerPortal, v as zLocationName, nn as zLongitude, to as zMaxCutOffTime, fe as zMinCutOffTime, Ka as zMondayDelivery, Rt as zNotificationGroupId, qt as zNotificationGroupIds, fn as zNotificationPostNotificationGroupRequest, ke as zNotificationPutNotificationTemplateRequest, nt as zNotificationResponsesNotificationGroups, kt as zNotificationResponsesNotificationTemplates, An as zNotificationTemplateId, Rc as zNumber, xe as zOrder, fr as zOrderDefsShippedItemPropertiesOrderLine, qe as zOrderDefsShippedItemPropertiesOrderLineIdentifier, rr as zOrderDefsShippedItemPropertiesPicklistIdentifier, xr as zOrderDefsShippedItemPropertiesQuantity, Re as zPackageType, bt as zPage, ss as zPatchShipments, dt as zPatchShipmentsData, zr as zPatchShipmentsResponse, Ar as zPlatform, Jr as zPositions, xn as zPostCapabilities, re as zPostCapabilitiesContractDefinitions, qi as zPostCapabilitiesContractDefinitionsData, Ns as zPostCapabilitiesContractDefinitionsResponse, Oo as zPostCapabilitiesData, ps as zPostCapabilitiesResponse, Na as zPostNotificationGroups, li as zPostNotificationGroupsData, Ro as zPostNotificationGroupsResponse, Cs as zPostRates, Oi as zPostRatesData, so as zPostRatesResponse, Us as zPostShipments, Ri as zPostShipmentsData, ra as zPostShipmentsResponse, Jo as zPostUnrelatedReturnShipmentsData, vo as zPostUnrelatedReturnShipmentsResponse, Ca as zPostWebhookSubscriptions, pa as zPostWebhookSubscriptionsData, ei as zPostWebhookSubscriptionsResponse, $s as zPostalCode, Ec as zPutNotificationTemplateData, yi as zPutNotificationTemplateResponse, _c as zPutNotificationTemplates, In as zPutShipmentData, o as zPutShipmentResponse, cc as zPutShipments, Gn as zQ, w as zRatesPostRatesRequestV1, h as zRatesPostRatesRequestV2, $t as zRatesResponsesRatesV1, Qa as zRefCapabilitiesContractDefinitionsResponseContractDefinitionsV1, le as zRefCapabilitiesContractDefinitionsResponseContractDefinitionsV2, Ua as zRefCapabilitiesContractDefinitionsResponseOptionsInsuranceOptionV1, Ft as zRefCapabilitiesContractDefinitionsResponseOptionsInsuranceOptionV2, Wt as zRefCapabilitiesContractDefinitionsResponseOptionsOptionV1, ln as zRefCapabilitiesContractDefinitionsResponseOptionsOptionV2, Ee as zRefCapabilitiesContractDefinitionsResponseOptionsOptionsV1, $e as zRefCapabilitiesContractDefinitionsResponseOptionsOptionsV2, Et as zRefCapabilitiesResponseCapabilityV1, Dn as zRefCapabilitiesResponseCapabilityV2, Fc as zRefCapabilitiesResponseCollo, ve as zRefCapabilitiesResponseOptionsInsuranceOptionV1, lr as zRefCapabilitiesResponseOptionsInsuranceOptionV2, We as zRefCapabilitiesResponseOptionsOptionV1, er as zRefCapabilitiesResponseOptionsOptionV2, vr as zRefCapabilitiesResponseOptionsOptionsV1, Fe as zRefCapabilitiesResponseOptionsOptionsV2, _t as zRefCapabilitiesResponsePhysicalPropertiesPhysicalPropertiesV1, is as zRefCapabilitiesResponsePhysicalPropertiesPhysicalPropertiesV2, ct as zRefCapabilitiesResponsePhysicalPropertiesPhysicalProperty, Ir as zRefCapabilitiesSharedCarrier, Dr as zRefCapabilitiesSharedCarrierV2, Gr as zRefCapabilitiesSharedContractV1, vn as zRefCapabilitiesSharedContractV2, ee as zRefCapabilitiesSharedOptionsBaseOptionV1, Gi as zRefCapabilitiesSharedOptionsBaseOptionV2, js as zRefCapabilitiesSharedOptionsBaseOptionsV1, Eo as zRefCapabilitiesSharedOptionsBaseOptionsV2, ds as zRefCapabilitiesSharedOptionsInsuranceBaseInsuranceV1, ja as zRefCapabilitiesSharedOptionsInsuranceBaseInsuranceV2, si as zRefNotificationNotificationTemplateType, Io as zRefNotificationResponseNotificationGroup, xs as zRefNotificationResponseNotificationTemplate, Ei as zRefRatesResponseContract, ao as zRefRatesResponseContractV2, Vs as zRefRatesResponsePriceCompositionPriceCompositionV1, Ii as zRefRatesResponsePriceCompositionPriceCompositionV2, ta as zRefRatesResponsePriceCompositionPriceV1, Ko as zRefRatesResponsePriceCompositionPriceV2, go as zRefRatesResponseRateV1, xa as zRefRatesResponseRateV2, da as zRefShipmentAddressV2, Qr as zRefShipmentBpostBpostPugoType, Zs as zRefShipmentCustomsDeclaration, wc as zRefShipmentCustomsDeclarationItem, _i as zRefShipmentGeneralSettings, hc as zRefShipmentLabelPrintingPosition, Pn as zRefShipmentLocationType, i as zRefShipmentLocationTypeV2, oc as zRefShipmentLocationV2, Un as zRefShipmentOptionsDeliveryTypeAll, S as zRefShipmentOptionsDeliveryTypeDeliveryDate, p as zRefShipmentOptionsInsurance, Zt as zRefShipmentOptionsInsuranceMax, Xa as zRefShipmentOptionsLabelDescription, se as zRefShipmentOptionsOptions, Va as zRefShipmentOptionsOptionsReturns, Nt as zRefShipmentOptionsPackageTypeAll, Ht as zRefShipmentOptionsPackageTypeReturns, sn as zRefShipmentPackageType, we as zRefShipmentPackageType1Package, Ze as zRefShipmentPackageType2Mailbox, wt as zRefShipmentPackageType6SmallPackage, Tn as zRefShipmentPackageTypeV2, Nc as zRefShipmentPhysicalPropertiesPropertiesHeight, ge as zRefShipmentPhysicalPropertiesPropertiesLength, sr as zRefShipmentPhysicalPropertiesPropertiesVolume, He as zRefShipmentPhysicalPropertiesPropertiesWeight, Qn as zRefShipmentPhysicalPropertiesPropertiesWidth, gr as zRefShipmentPickup, Ne as zRefShipmentPickupV2, ht as zRefShipmentRecipientSecondaryEmails, ns as zRefShipmentReferenceIdentifier, ot as zRefShipmentSender, Pr as zRefShipmentShipmentOptions, Tr as zRefShipmentShipmentOptionsReturns, Ur as zRefShipmentShipmentTypeV2, gn as zRefShipmentTransactionStatus, t as zRefShipmentType, Xi as zRefTypesCarrier, Is as zRefTypesCarrierReturns, jo as zRefTypesCc, gs as zRefTypesDeliveryType, Ia as zRefTypesDeliveryTypeV2, fi as zRefTypesIntBoolean, Vo as zRefTypesMoney, Es as zRefTypesMoneyNullableAmount, ji as zRefTypesMoneyPropertiesAmount, uo as zRefTypesMoneyPropertiesCurrency, Ks as zRefTypesPriceEuro, Vi as zRefTypesShipmentType, oa as zRefTypesTransactionTypes, Zo as zRefTypesValueWithUnit, xo as zRefWebhookWebhookV10, Ea as zRefWebhookWebhookV11, ga as zReference, ni as zReferenceIdentifier, tc as zRegion, Oc as zSendTestNotificationData, xi as zSendTestNotificationResponse, yc as zShipmentDefsCarrierTrackTraceEvent, Rn as zShipmentDefsCarrierTrackTraceHistory, c as zShipmentDefsCustomsShipmentType, uc as zShipmentDefsDeliveryMomentPropertiesTimeFrame, qn as zShipmentDefsDeliveryMomentPropertiesType, E as zShipmentDefsDeliveryOptionsDeliveryNameV2, _ as zShipmentDefsDeliveryOptionsDeliveryTimeFrame, tn as zShipmentDefsDeliveryOptionsOpeningHours, eo as zShipmentDefsDeliveryOptionsOpeningHoursDefinitionsOpeningHours, de as zShipmentDefsDeliveryOptionsPickup, Ga as zShipmentDefsDeliveryOptionsPickupTime, Lt as zShipmentDefsExternalProviderPropertiesDisplayName, Kt as zShipmentDefsExternalProviderPropertiesId, dn as zShipmentDefsExternalTrackTraceLink, Oe as zShipmentDefsMainStatus, tt as zShipmentDefsOccupancy, Ot as zShipmentDefsShipment, kn as zShipmentDefsShipmentCarrierPropertiesExternalIdentifier, Lc as zShipmentDefsShipmentDropOffPoint, be as zShipmentDefsShipmentOriginPropertiesOrigin, dr as zShipmentDefsShipmentOriginPropertiesUserAgent, Ke as zShipmentDefsShipmentPartnerTracktraces, nr as zShipmentDefsShipmentPaymentStatus, br as zShipmentDefsShipmentPhysicalProperties, Le as zShipmentDefsShipmentPhysicalPropertiesPropertiesHeight, yt as zShipmentDefsShipmentPhysicalPropertiesPropertiesLength, os as zShipmentDefsShipmentPhysicalPropertiesPropertiesVolume, ut as zShipmentDefsShipmentPhysicalPropertiesPropertiesWeight, Rr as zShipmentDefsShipmentPhysicalPropertiesPropertiesWidth, kr as zShipmentDefsShipmentPickup, qr as zShipmentDefsShipmentPropertiesAccountId, bn as zShipmentDefsShipmentPropertiesAmount, ne as zShipmentDefsShipmentPropertiesBarcode, Qi as zShipmentDefsShipmentPropertiesCarrierId, Rs as zShipmentDefsShipmentPropertiesCollectionContact, No as zShipmentDefsShipmentPropertiesContractId, vs as zShipmentDefsShipmentPropertiesCreated, Ra as zShipmentDefsShipmentPropertiesCreatedBy, mi as zShipmentDefsShipmentPropertiesCurrency, Uo as zShipmentDefsShipmentPropertiesCustomsDeclaration, Os as zShipmentDefsShipmentPropertiesDelayed, Ni as zShipmentDefsShipmentPropertiesDelivered, po as zShipmentDefsShipmentPropertiesDropOffPoint, Js as zShipmentDefsShipmentPropertiesExternalIdentifier, Ui as zShipmentDefsShipmentPropertiesExternalProvider, ca as zShipmentDefsShipmentPropertiesExternalProviderId, $o as zShipmentDefsShipmentPropertiesGeneralSettings, Co as zShipmentDefsShipmentPropertiesHidden, Oa as zShipmentDefsShipmentPropertiesId, va as zShipmentDefsShipmentPropertiesLinkConsumerPortal, ii as zShipmentDefsShipmentPropertiesModified, rc as zShipmentDefsShipmentPropertiesModifiedBy, Ac as zShipmentDefsShipmentPropertiesMultiColloMainShipmentId, Ci as zShipmentDefsShipmentPropertiesOptions, xc as zShipmentDefsShipmentPropertiesOrderShipmentIdentifier, Bn as zShipmentDefsShipmentPropertiesOrigin, u as zShipmentDefsShipmentPropertiesParentId, fc as zShipmentDefsShipmentPropertiesPartnerTracktraces, Yn as zShipmentDefsShipmentPropertiesPaymentStatus, O as zShipmentDefsShipmentPropertiesPhysicalProperties, y as zShipmentDefsShipmentPropertiesPickup, rn as zShipmentDefsShipmentPropertiesPickupRequestNumber, no as zShipmentDefsShipmentPropertiesPlatformId, pe as zShipmentDefsShipmentPropertiesPrice, qa as zShipmentDefsShipmentPropertiesRecipient, zt as zShipmentDefsShipmentPropertiesReferenceIdentifier, Jt as zShipmentDefsShipmentPropertiesRegion, pn as zShipmentDefsShipmentPropertiesSender, Ae as zShipmentDefsShipmentPropertiesShipmentType, rt as zShipmentDefsShipmentPropertiesShippedItems, At as zShipmentDefsShipmentPropertiesShopId, jn as zShipmentDefsShipmentPropertiesStatus, zc as zShipmentDefsShipmentPropertiesTransactionStatus, Se as zShipmentDefsShipmentPropertiesUserAgent, pr as zShipmentDefsShipmentRecipient, Je as zShipmentDefsShipmentSender, ir as zShipmentDefsShipmentSenderPropertiesEmail, Sr as zShipmentDefsShipmentShippedItem, ze as zShipmentDefsShipmentStatus, xt as zShipmentDefsTrackTrace, cs as zShipmentDefsTrackTraceProofOfDelivery, ft as zShipmentDefsTrackingLocation, Br as zShipmentIds, jr as zShipmentParametersBarcode, Yr as zShipmentParametersCarrierId, Sn as zShipmentParametersCarrierIdentifier, ie as zShipmentParametersCarrierName, Ki as zShipmentParametersCollectDate, Ms as zShipmentParametersCutoffTime, Do as zShipmentParametersDeliveryDate, fs as zShipmentParametersDeliveryOptionsIdentifier, Ma as zShipmentParametersDeliveryTime, ci as zShipmentParametersDeliveryType, Lo as zShipmentParametersDeliveryTypes, Ss as zShipmentParametersLabelPosition, Di as zShipmentParametersPackageType, oo as zShipmentParametersPaperSize, Hs as zShipmentParametersPostalCode, Li as zShipmentParametersShipmentType, na as zShipmentParametersSortShipment, qo as zShipmentParametersStatus, _o as zShipmentParametersTracktracesExtraInfo, Sa as zShipmentPatchShipmentsRequest, fa as zShipmentPostReturnShipmentsRequest, $r as zShipmentPostShipmentsRequest, Qs as zShipmentPostShipmentsRequestV11, Tc as zShipmentPostUnrelatedReturnShipmentsRequest, vi as zShipmentPutShipmentsRequest, gc as zShipmentPutShipmentsRequestV11, Fn as zShipmentResponsesBulkShipmentLabelsPaymentRequired, a as zShipmentResponsesDeliveryOptionsDeliveryOptionV1, sc as zShipmentResponsesDeliveryOptionsDeliveryOptionV2, Wn as zShipmentResponsesDeliveryOptionsDeliveryPossibility, C as zShipmentResponsesDeliveryOptionsDeliveryTime, m as zShipmentResponsesDeliveryOptionsPackageTypeV2, Qt as zShipmentResponsesDeliveryOptionsV1, Za as zShipmentResponsesDeliveryOptionsV2, ce as zShipmentResponsesDownloadableLabel, Ha as zShipmentResponsesDropOffPoint, Pt as zShipmentResponsesDropOffPointDefinitionsAvailableDays, Ut as zShipmentResponsesDropOffPointDefinitionsOpeningHours, cn as zShipmentResponsesDropOffPointDefinitionsTimeframe, Te as zShipmentResponsesDropOffPointDefinitionsTimeframes, Qe as zShipmentResponsesDropOffPoints, Tt as zShipmentResponsesPaymentInstructions, En as zShipmentResponsesPickupLocations, Pc as zShipmentResponsesPickupLocationsDefinitionsAddress, _e as zShipmentResponsesPickupLocationsDefinitionsLocation, cr as zShipmentResponsesPickupLocationsDefinitionsOpeningHours, Ue as zShipmentResponsesPickupLocationsDefinitionsPickupLocation, $n as zShipmentResponsesPickupLocationsDefinitionsPossibilities, _r as zShipmentResponsesPickupLocationsDefinitionsTimeframe, Pe as zShipmentResponsesPostShipmentsV12, gt as zShipmentResponsesPutShipmentsV12, rs as zShipmentResponsesShipmentIds, st as zShipmentResponsesShipmentIdsPropertiesDataPropertiesIds, Fr as zShipmentResponsesShipmentLabels, Er as zShipmentResponsesShipments, Wr as zShipmentResponsesTracktraces, _n as zShipmentType, n as zShopId, Ji as zShopId2, Ps as zSize, ko as zSortShipment, ms as zSortTracktraces, Pa as zStatus, ui as zStreet, zo as zTracktraceExternalIdentifier, ws as zTransactionStatus, ki as zUserAgent, co as zWebhookSubscriptionIds, Ws as zWebhooksPostWebhookSubscriptionsRequestV10, zi as zWebhooksPostWebhookSubscriptionsRequestV11, ia as zWebhooksResponsesPostWebhookSubscriptions, Yo as zWebhooksResponsesWebhookSubscriptionsV10, yo as zWebhooksResponsesWebhookSubscriptionsV11, wa as zWebhooksResponsesWebhookV10, ma as zWebhooksResponsesWebhookV11 };
